import React, { ComponentProps } from "react";
import classnames from "classnames";

// Site to simplify SVG: https://jakearchibald.github.io/svgomg/

// customizable

export const BractletSymbol = ({
  className,
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      className={classnames("icon", className)}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="72"
      viewBox="0 0 70 72"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <path d="M.06 0h68.987v71.94H.06z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          className="fill"
          d="M66.844 52.02l-16.823-9.713V29.693l16.823-9.713 2.203 3.816-14.619 8.441v7.527l14.619 8.439-2.203 3.817M2.203 52.02L0 48.203l14.62-8.439v-7.527L0 23.796l2.203-3.816 16.823 9.713v12.614L2.203 52.02M47.872 25.732l-10.923-6.307V0h4.406v16.881l6.517 3.764 14.621-8.441 2.203 3.815-16.824 9.713M32.442 72h-4.406V55.118l-6.517-3.763-14.621 8.442-2.202-3.817 16.823-9.712 10.923 6.306V72M21.519 25.732L4.696 16.019l2.202-3.815 14.621 8.441 6.517-3.764V0h4.406v19.425l-10.923 6.307M41.355 72h-4.406V52.574l10.923-6.306 16.824 9.712-2.203 3.817-14.621-8.442-6.517 3.763V72"
        />
      </g>
    </svg>
  );
};

export const BackpackSymbolOutline = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="22"
    height="21.404"
    viewBox="0 0 22 21.404"
    {...props}
  >
    <g transform="translate(-192.996 -1378.821)">
      <g
        transform="translate(192.996 1378.821)"
        fill="none"
        stroke="#b9c3e1"
        strokeLinecap="round"
        strokeWidth="2"
        className="stroke"
      >
        <rect width="22" height="10" stroke="none" className="stroke" />
        <rect
          x="1"
          y="1"
          width="20"
          height="9"
          fill="none"
          className="stroke"
        />
      </g>
      <g transform="translate(0.451 14.612)" fill="none" strokeLinecap="round">
        <path d="M192.549,1373.2v12.412h22V1373.2Z" stroke="none" />
        <path
          d="M 194.5488128662109 1375.201416015625 L 194.5488128662109 1383.613037109375 L 212.5448913574219 1383.613037109375 L 212.5448913574219 1375.201416015625 L 194.5488128662109 1375.201416015625 M 192.5488128662109 1373.201416015625 L 214.5448913574219 1373.201416015625 L 214.5448913574219 1385.613037109375 L 192.5488128662109 1385.613037109375 L 192.5488128662109 1373.201416015625 Z"
          stroke="none"
          fill="#b9c3e1"
          className="fill"
        />
      </g>
      <g transform="translate(200.763 1388.297)">
        <path
          d="M198.5,1389.186v4.941"
          transform="translate(-198.496 -1389.186)"
          fill="none"
          stroke="#b9c3e1"
          strokeWidth="2"
          className="stroke"
        />
        <path
          d="M198.5,1389.186v4.941"
          transform="translate(-192.027 -1389.186)"
          fill="none"
          stroke="#b9c3e1"
          strokeWidth="2"
          className="stroke"
        />
      </g>
    </g>
  </svg>
);

export const OnboardingGuideIcon = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="15.964"
    viewBox="0 0 16 15.964"
    {...props}
  >
    <path
      className="fill"
      d="M7.6,15.9l-7-3A.875.875,0,0,1,0,12V1A.986.986,0,0,1,1.4.1L8,2.9,14.6.1A.986.986,0,0,1,16,1V12a.875.875,0,0,1-.6.9l-7,3A1.1,1.1,0,0,1,7.6,15.9ZM2,11.3l6,2.6,6-2.6V2.5L8.4,4.9a1.1,1.1,0,0,1-.8,0L2,2.5Z"
      transform="translate(0 -0.011)"
      // fill="#fff"
    />
    <rect
      className="fill"
      width="4.4"
      height="1"
      transform="translate(3.181 5.363) rotate(23.199)"
      // fill="#fff"
    />
    <rect
      className="fill"
      width="4.4"
      height="1"
      transform="translate(3.158 8.558) rotate(23.199)"
      // fill="#fff"
    />
    <rect
      className="fill"
      width="1"
      height="4.4"
      transform="translate(12.839 5.373) rotate(66.814)"
      // fill="#fff"
    />
    <rect
      className="fill"
      width="1"
      height="4.4"
      transform="translate(12.786 8.538) rotate(66.814)"
      // fill="#fff"
    />
  </svg>
);

export const MapIcon = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="22.562"
    viewBox="0 0 24 22.562"
    {...props}
  >
    <g transform="translate(0 -0.719)">
      <line
        y2="18"
        transform="translate(9 2)"
        fill="none"
        className="stroke"
        stroke="#9a9eb2"
        strokeWidth="2"
      />
      <line
        y2="18"
        transform="translate(15 4)"
        fill="none"
        className="stroke"
        stroke="#9a9eb2"
        strokeWidth="2"
      />
      <path
        d="M1,4,9,2l6,2,8-2V20l-8,2L9,20,1,22Z"
        fill="none"
        className="stroke"
        stroke="#9a9eb2"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const Home = ({ className, ...props }: ComponentProps<"svg">) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className={classnames("icon", className)}
      {...props}
    >
      <g transform="translate(36 0)">
        <path
          className="fill"
          d="M11.515,3.143l-5-3a1,1,0,0,0-1.03,0l-5,3A1,1,0,0,0,0,4v7a1,1,0,0,0,1,1H11a1,1,0,0,0,1-1V4a1,1,0,0,0-.485-.857ZM10,10H7V7H5v3H2V4.566l4-2.4,4,2.4Z"
          transform="translate(-36)"
        />
      </g>
    </svg>
  );
};

export const OfficeTenants = ({
  className,
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="26"
      viewBox="0 0 24 26"
      className={classnames("icon", className)}
      {...props}
    >
      <defs />
      <g transform="translate(1 1)">
        <path
          className="stroke"
          d="M18.729,11V1H6V8"
          transform="translate(-1.729 -1)"
        />
        <rect
          className="stroke"
          width="9"
          height="11"
          transform="translate(0 11)"
        />
        <line className="stroke" x2="1" transform="translate(10 4)" />
        <line className="stroke" x2="1" transform="translate(10 7)" />
        <line className="stroke" x2="1" transform="translate(4 18)" />
        <line className="stroke" x2="1" transform="translate(4 15)" />
        <circle
          className="stroke"
          cx="2"
          cy="2"
          r="2"
          transform="translate(15 13)"
        />
        <path
          className="stroke"
          d="M12,14a5,5,0,0,0-5,5H17A5,5,0,0,0,12,14Z"
          transform="translate(5 4)"
        />
      </g>
    </svg>
  );
};

export const RetailTenants = ({
  className,
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="23"
      viewBox="0 0 25 23"
      className={classnames("icon", className)}
      {...props}
    >
      <defs />
      <g transform="translate(1 1)">
        <path
          className="stroke"
          d="M13.374,12A2.5,2.5,0,0,1,11,9.5a2.5,2.5,0,0,1-5,0A2.5,2.5,0,0,1,3.5,12C2.119,12,1,10.958,1,9L5,1H17l4,8"
          transform="translate(-1 -1)"
        />
        <path
          className="stroke"
          d="M5.522,10.895A3.2,3.2,0,0,0,6,9"
          transform="translate(14 -1)"
        />
        <path className="stroke" d="M4,12v9h8" transform="translate(-1 -1)" />
        <circle
          className="stroke"
          cx="2"
          cy="2"
          r="2"
          transform="translate(15 11.051)"
        />
        <path
          className="stroke"
          d="M12,14a5,5,0,0,0-5,5H17A5,5,0,0,0,12,14Z"
          transform="translate(5 2.051)"
        />
      </g>
    </svg>
  );
};

export const CopyText = ({ className, ...props }: ComponentProps<"svg">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      className={classnames("icon", className)}
      {...props}
    >
      <defs />
      <g transform="translate(-1)">
        <rect
          className="stroke"
          width="16"
          height="18"
          transform="translate(2 5)"
        />
        <path className="stroke" d="M5,1H22V21" />
        <line className="stroke" x2="8" transform="translate(6 10)" />
        <line className="stroke" x2="8" transform="translate(6 14)" />
        <line className="stroke" x2="4" transform="translate(6 18)" />
      </g>
    </svg>
  );
};

export const GenerateLinks = ({
  className,
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      className={classnames("icon", className)}
      width="23.414"
      height="23.414"
      viewBox="0 0 23.414 23.414"
      {...props}
    >
      <g transform="translate(-0.586 -0.586)">
        <path className="stroke" d="M14.5,2.5s-3-1-5,1l-6,6c-2,2-1,5-1,5" />
        <path className="stroke" d="M19.5,7.5s1,3-1,5l-6,6c-2,2-5,1-5,1" />
        <line className="stroke" x1="6" y2="6" transform="translate(2 14)" />
        <line className="stroke" x1="6" y2="6" transform="translate(14 2)" />
        <line className="stroke" y2="6" transform="translate(20 17)" />
        <line className="stroke" x2="6" transform="translate(17 20)" />
      </g>
    </svg>
  );
};

export const Submit = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="17.824"
    height="16.009"
    viewBox="0 0 17.824 16.009"
    {...props}
  >
    <g transform="translate(1 1)">
      <path
        className="stroke"
        d="M687.025,377.5a7,7,0,1,0,.05,8.7"
        transform="translate(-674.554 -374.874)"
      />
      <line
        className="stroke"
        strokeWidth="2px"
        x2="8"
        transform="translate(6.654 6.994)"
      />
      <path
        className="fill"
        strokeWidth="1px"
        d="M670.43,386.063l2.1-2.1-2.1-2.1"
        transform="translate(-657.121 -376.967)"
      />
    </g>
  </svg>
);

export const Require = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <g transform="translate(0 -0.979)">
      <rect
        className="fill"
        width="2"
        height="4"
        transform="translate(7.001 5.957)"
      />
      <circle
        className="fill"
        cx="1"
        cy="1"
        r="1"
        transform="translate(7.001 10.957)"
      />
      <path
        className="fill"
        d="M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6.006,6.006,0,0,1,8,14Z"
        transform="translate(0 0.979)"
      />
    </g>
  </svg>
);

export const Cycle = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="20.828"
    viewBox="0 0 24 20.828"
    {...props}
  >
    <g transform="translate(0 -1.586)">
      <path className="stroke" d="M15,6h2a6,6,0,0,1,0,12H14l3,3" />
      <path className="stroke" d="M9,18H7A6,6,0,0,1,7,6h3L7,3" />
    </g>
  </svg>
);

export const Gresb = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="24"
    viewBox="0 0 24 23.99"
    {...props}
  >
    <defs />
    <g transform="translate(-161.936 -211.084)">
      <path
        className="fill"
        d="M297.678,211.084a.2.2,0,0,0,0,.031h-1.13a.236.236,0,0,0,0-.03Z"
        transform="translate(-123.176 0)"
      />
      <path
        className="fill"
        d="M359.172,299.515c-.06.014-.1-.011-.122-.091q-.178-.68-.365-1.356c-.03-.106.031-.132.105-.164l1.557-.692,4.381-1.95a.753.753,0,0,0,.1-.043c.077-.049.114-.015.143.059.095.246.2.488.289.736a11.993,11.993,0,0,1,.624,2.661c.015.126.016.131-.122.147-.285.034-.571.063-.856.093l-1.87.2-1.486.155-1.538.163Z"
        transform="translate(-180.024 -76.964)"
      />
      <path
        className="fill"
        d="M174.879,373.788c.073.007.079.069.1.113q.322.625.641,1.251c.024.047.049.094.072.141.057.117.058.119-.05.2q-.59.43-1.181.857l-3.528,2.562c-.161.117-.161.117-.272-.04a11.976,11.976,0,0,1-1.544-3.025c-.057-.166-.057-.167.12-.224l4.659-1.512.885-.287Z"
        transform="translate(-6.541 -148.878)"
      />
      <path
        className="fill"
        d="M250.188,416.051c-.055.516-.112,1.04-.167,1.564-.052.489-.1.978-.153,1.467q-.1.943-.2,1.886c-.03.291-.058.582-.087.874-.013.134-.014.138-.146.124a11.433,11.433,0,0,1-2.23-.469c-.386-.12-.763-.264-1.135-.421-.139-.059-.14-.061-.079-.2q.538-1.212,1.078-2.423l1.286-2.888c.014-.032.03-.064.043-.1.023-.061.061-.071.124-.053.525.143,1.05.286,1.577.42C250.24,415.873,250.179,415.966,250.188,416.051Z"
        transform="translate(-76.878 -186.963)"
      />
      <path
        className="fill"
        d="M328.807,218.2a10.283,10.283,0,0,1,1.013.378,11.885,11.885,0,0,1,2.216,1.243c.114.081.115.083.031.2l-3.047,4.191c-.089.123-.077.1-.194.046l-1.579-.8c-.132-.067-.133-.07-.086-.214q.8-2.461,1.6-4.922C328.772,218.285,328.787,218.253,328.807,218.2Z"
        transform="translate(-151.16 -6.513)"
      />
      <path
        className="fill"
        d="M237.478,219.77c.017.1-.036.116-.085.135q-.3.118-.606.233c-.361.137-.722.273-1.082.412-.106.041-.125.047-.191-.07-.292-.513-.591-1.023-.887-1.535l-.835-1.443q-.43-.744-.859-1.49c-.077-.134-.07-.145.075-.225a11.75,11.75,0,0,1,3.048-1.187c.063-.015.125-.031.187-.045.1-.023.126-.013.147.086.062.279.12.559.18.839q.2.968.408,1.936.247,1.165.5,2.329C237.476,219.761,237.48,219.778,237.478,219.77Z"
        transform="translate(-64.92 -3.167)"
      />
      <path
        className="fill"
        d="M303.183,428.85v-2.5c0-.041,0-.082,0-.123,0-.065.029-.089.094-.1.288-.043.575-.092.863-.138l.829-.132c.023,0,.046-.007.07-.009.165-.014.168-.013.221.149q.409,1.25.817,2.5.378,1.159.753,2.318l.015.05c.044.142.045.147-.107.191-.252.073-.505.144-.761.206a11.822,11.822,0,0,1-1.464.255,9.485,9.485,0,0,1-1.154.066c-.174,0-.176,0-.176-.173Q303.182,430.132,303.183,428.85Z"
        transform="translate(-129.245 -196.514)"
      />
      <path
        className="fill"
        d="M368.014,387.19c.047.02.1.039.144.06l2.775,1.235,1.267.564c.136.061.138.064.08.188a11.99,11.99,0,0,1-1.9,2.919c-.091.1-.1.1-.2.006q-1.157-1.039-2.312-2.081c-.34-.306-.678-.613-1.02-.915-.068-.06-.084-.105-.029-.188.374-.567.742-1.138,1.113-1.707C367.949,387.239,367.965,387.2,368.014,387.19Z"
        transform="translate(-187.439 -161.142)"
      />
      <path
        className="fill"
        d="M201.4,415.245c-.02-.011-.047-.023-.071-.037a12.315,12.315,0,0,1-1.562-1.1,14.275,14.275,0,0,1-1.148-1.086c-.1-.1-.1-.108.005-.2.32-.291.644-.578.966-.868l.782-.706q.672-.6,1.345-1.208c.083-.074.162-.153.242-.231a.121.121,0,0,1,.185-.006q.564.461,1.131.918c.154.125.305.256.465.374.071.052.066.1.029.16q-.531.909-1.06,1.82c-.328.567-.654,1.136-.981,1.7-.079.137-.159.273-.239.409A.107.107,0,0,1,201.4,415.245Z"
        transform="translate(-33.5 -181.791)"
      />
      <path
        className="fill"
        d="M161.942,338.943c-.027-.307.034-.655.037-1.006a.865.865,0,0,1,.018-.1c.01-.073.051-.1.121-.091.249.027.5.044.748.083.156.025.314.029.47.05.434.059.87.1,1.305.142.285.029.571.046.855.079.342.039.684.08,1.028.107.04,0,.08.021.12.025a.085.085,0,0,1,.088.088,1.376,1.376,0,0,1,.024.155c-.01.357.03.713.048,1.069.014.286.015.573.044.858.008.077-.014.105-.084.12q-.917.192-1.833.387l-1.884.4-.7.152c-.128.027-.133.023-.166-.1a5.378,5.378,0,0,1-.126-.723A11.188,11.188,0,0,1,161.942,338.943Z"
        transform="translate(0 -115.895)"
      />
      <path
        className="fill"
        d="M191.726,238.428c.062.015.079.062.105.1q.374.511.745,1.023l1.436,1.977a.923.923,0,0,0,.063.085c.056.061.042.106-.015.162-.219.212-.432.43-.648.645q-.473.473-.946.945c-.091.091-.093.091-.2.015l-3.073-2.232c-.107-.078-.117-.067-.029-.186a12.075,12.075,0,0,1,2.466-2.466C191.664,238.471,191.7,238.448,191.726,238.428Z"
        transform="translate(-24.862 -25.02)"
      />
      <path
        className="fill"
        d="M346.137,425.125a4.287,4.287,0,0,1-.6.52,12.278,12.278,0,0,1-2.391,1.465.519.519,0,0,0-.063.031c-.071.045-.1.008-.131-.055q-.521-1.18-1.045-2.359-.246-.554-.5-1.1c-.067-.147-.07-.149.064-.235.618-.4,1.238-.8,1.855-1.206.072-.047.115-.052.175.016.264.3.534.59.8.886.149.165.294.334.443.5q.548.606,1.1,1.21C345.944,424.9,346.037,425.01,346.137,425.125Z"
        transform="translate(-164.185 -193.127)"
      />
      <path
        className="fill"
        d="M402.07,352.276h1.476c.208,0,.214,0,.208.2-.011.42-.046.838-.093,1.256a12.149,12.149,0,0,1-.326,1.7c-.036.136-.074.271-.116.4s-.058.152-.214.1c-.123-.038-.246-.075-.368-.115l-2.485-.811c-.176-.058-.184-.065-.155-.249.075-.478.156-.955.232-1.433.041-.259.078-.519.117-.778.005-.034.009-.069.016-.1.038-.176.038-.177.214-.177Z"
        transform="translate(-217.821 -129.195)"
      />
      <path
        className="fill"
        d="M289.14,211.441h1.13a11.668,11.668,0,0,1,1.775.216c.153.031.156.03.122.192-.164.778-.332,1.555-.493,2.333-.02.1-.068.118-.157.113-.321-.019-.643-.032-.965-.049l-1.052-.058c-.222-.012-.444-.026-.666-.033-.078,0-.113-.024-.121-.108-.027-.291-.064-.581-.094-.872-.054-.518-.106-1.035-.161-1.553-.014-.13-.016-.131.122-.141Z"
        transform="translate(-115.766 -0.327)"
      />
      <path
        className="fill"
        d="M166.589,281.868c.328.187,1.351.644,1.659.822.145.084.148.107.086.269q-.53,1.384-1.059,2.768c-.01.027-.023.054-.033.081-.03.086-.078.111-.174.088-.312-.074-1.34-.416-1.654-.483-.151-.032-.175-.066-.139-.217a12.239,12.239,0,0,1,.7-2.112A12.047,12.047,0,0,1,166.589,281.868Z"
        transform="translate(-3.043 -64.769)"
      />
      <path
        className="fill"
        d="M388.909,247.941a.2.2,0,0,1,.1.07c.361.352.714.71,1.039,1.1a12.419,12.419,0,0,1,.906,1.228c.089.137.171.279.258.418.037.058.021.091-.038.124-.3.17-1.192.97-1.491,1.141-.115.066-.119.066-.21-.044q-.341-.413-.677-.829-.426-.524-.85-1.049c-.147-.182-.292-.366-.442-.544-.048-.057-.051-.1,0-.148.079-.078.151-.163.223-.248.151-.178.908-.972,1.067-1.143C388.827,247.98,388.854,247.938,388.909,247.941Z"
        transform="translate(-206.926 -33.725)"
      />
    </g>
  </svg>
);

export const LeedEmblem = ({
  className,
  whiteAccent,
  ...props
}: ComponentProps<"svg"> & { whiteAccent?: boolean }) => (
  <svg
    className={classnames("leed-emblem-icon", className, {
      "white-accent": whiteAccent,
    })}
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(-906.037 -223.211)">
      <circle
        className="fill-color"
        cx="22"
        cy="22"
        r="22"
        transform="translate(906.037 223.211)"
        opacity=".2"
      />
      <path
        className="fill"
        d="M928.037 262.041a16.829 16.829 0 1116.829-16.829 16.848 16.848 0 01-16.829 16.829zm0-33.2a16.375 16.375 0 1016.375 16.375 16.393 16.393 0 00-16.375-16.379z"
      />
      <path
        className="fill"
        d="M942.842 245.863c-.236-.526-.5-.638-1.049-.441-.356.127-.786.411-1.057.034-.3-.414.2-.671.425-.951.255-.312.537-.6.8-.909a2.9 2.9 0 00.745-2.014c-.013-.488-.221-.742-.738-.741-.63 0-.766-.147-.706-.805a2.187 2.187 0 00-.632-1.963 1.292 1.292 0 00-1.42-.3 1.152 1.152 0 00-.738 1.174 7.713 7.713 0 01-.06.82c-.014.116.016.283-.149.32-.143.032-.235-.087-.317-.182-.227-.263-.422-.544-.85-.5-.519.051-.765.263-.805.782a6.945 6.945 0 00.4 2.092 3.088 3.088 0 01.161.971c-.018.191.07.461-.165.532-.207.063-.356-.156-.485-.3-.2-.236-.373-.5-.579-.733-.543-.612-.912-.543-1.224.219a3.874 3.874 0 00-.041 2.006c.113.926.387 1.829.41 2.767 0 .2.1.5-.179.563-.231.052-.367-.2-.494-.378-.147-.21-.277-.432-.436-.632a.781.781 0 00-1.042-.181c-.391.187-.331.547-.244.862.156.564.355 1.117.54 1.672a4.946 4.946 0 01.012 3.546.389.389 0 00.03.461 22.7 22.7 0 003.881-5.087 32.159 32.159 0 002.5-5.888 4.038 4.038 0 01-.3 1.825c-1.8 5.371-4.838 9.8-9.786 12.755-.605.362-.651.334-.663-.355 0-.257 0-.514.007-.77a2.24 2.24 0 011.227-2.158 7.517 7.517 0 002.072-1.619 2.7 2.7 0 00.56-.808 1.064 1.064 0 00-.606-1.532.537.537 0 00-.051-.021c-.621-.2-1.161-.477-1.257-1.217-.1-.786.405-1.176.962-1.585a5.058 5.058 0 002.252-4.08c.024-.966-.43-1.323-1.39-1.167-.271.044-.533.135-.8.178-.714.114-.952-.17-.678-.834.2-.473.43-.931.67-1.384a8.557 8.557 0 00.95-2.964 1.936 1.936 0 00-.231-1.219.778.778 0 00-1.229-.347c-.348.2-.66.463-1.007.664s-.579.08-.652-.332a4.6 4.6 0 01.124-1.472 5.3 5.3 0 00-.182-2.174 1.29 1.29 0 00-2.573 0 5.309 5.309 0 00-.182 2.174 4.6 4.6 0 01.124 1.472c-.073.411-.294.54-.652.332s-.659-.464-1.007-.664a.779.779 0 00-1.23.347 1.94 1.94 0 00-.231 1.219 8.552 8.552 0 00.95 2.964c.24.453.474.911.67 1.384.275.663.036.948-.677.834-.27-.043-.533-.134-.8-.178-.96-.155-1.414.2-1.39 1.167a5.058 5.058 0 002.252 4.08c.556.409 1.063.8.962 1.585-.1.74-.635 1.02-1.257 1.217a.485.485 0 00-.051.021 1.064 1.064 0 00-.606 1.532 2.69 2.69 0 00.561.808 7.513 7.513 0 002.072 1.619 2.241 2.241 0 011.227 2.158c.01.257.011.514.007.77-.012.689-.058.716-.663.355-4.949-2.957-7.987-7.384-9.787-12.755a4.039 4.039 0 01-.3-1.825 32.168 32.168 0 002.5 5.888 22.7 22.7 0 003.881 5.087.389.389 0 00.03-.461 4.945 4.945 0 01.012-3.546c.186-.556.384-1.108.54-1.672.087-.315.146-.675-.244-.862a.781.781 0 00-1.042.181c-.16.2-.289.422-.437.632-.126.18-.263.43-.493.378-.276-.062-.184-.367-.179-.563.024-.938.3-1.841.41-2.767a3.878 3.878 0 00-.041-2.006c-.312-.762-.681-.831-1.224-.219-.206.233-.376.5-.579.733-.128.149-.277.368-.485.3-.234-.072-.147-.342-.164-.532a3.1 3.1 0 01.161-.971 6.937 6.937 0 00.4-2.092c-.041-.519-.286-.731-.805-.782-.427-.042-.622.238-.85.5-.082.1-.173.214-.317.182-.165-.037-.135-.2-.149-.32a7.713 7.713 0 01-.06-.82 1.152 1.152 0 00-.738-1.174 1.292 1.292 0 00-1.421.3 2.188 2.188 0 00-.632 1.959c.06.658-.077.806-.706.805-.517 0-.725.253-.739.741a2.905 2.905 0 00.745 2.014c.261.307.544.6.8.909.229.281.722.538.425.951-.271.377-.7.093-1.057-.034-.553-.2-.812-.086-1.049.441a1.475 1.475 0 00.485 1.816 7.631 7.631 0 002.1 1.177c.305.137.726.324.623.656s-.541.14-.829.088a.989.989 0 00-1.169 1.334 2.608 2.608 0 00.652 1.007 7.345 7.345 0 003.486 2 21.448 21.448 0 014.067 1.323 11.412 11.412 0 015.07 3.982.344.344 0 00.64 0 11.409 11.409 0 015.07-3.982 21.434 21.434 0 014.067-1.323 7.347 7.347 0 003.486-2 2.616 2.616 0 00.652-1.007.989.989 0 00-1.169-1.334c-.288.052-.725.248-.829-.088s.317-.519.623-.656a7.628 7.628 0 002.1-1.177 1.474 1.474 0 00.477-1.812z"
        opacity=".3"
      />
      <path
        className="fill"
        d="M912.958 256.381l-.357-.486.241-.177.542.738-1.275.937-.185-.251z"
      />
      <path
        className="fill"
        d="M911.916 254.822l-.338-.575.257-.151.5.844-1.364.8-.49-.834.257-.151.332.565.29-.171-.3-.516.253-.149.3.516z"
      />
      <path
        className="fill"
        d="M910.968 252.285l-.222.2.255.577.3-.028.136.308-1.671.132-.156-.353 1.222-1.148zm-.274.806l-.175-.4-.5.459z"
      />
      <path
        className="fill"
        d="M908.83 250.982a.719.719 0 01.064-.585.832.832 0 011.078-.322.721.721 0 01.374.454l.179.6-1.515.452zm1.23-.367a.439.439 0 00-.226-.282.5.5 0 00-.379-.021.493.493 0 00-.3.225.435.435 0 00-.036.36l.09.3.944-.282z"
      />
      <path
        className="fill"
        d="M909.575 248.593l-.114-.657.294-.051.168.964-1.558.272-.166-.953.294-.051.113.646.332-.058-.1-.59.289-.05.1.59z"
      />
      <path
        className="fill"
        d="M909.585 246.059l-.528.352.014.237.548-.034.02.311-1.579.1-.04-.632a.525.525 0 01.49-.558.514.514 0 01.479.276l.574-.387zm-1.253.635l.467-.029-.02-.32a.235.235 0 00-.467.029z"
      />
      <path
        className="fill"
        d="M909.201 244.874l-.142-.274a.356.356 0 00.26-.352c.009-.174-.057-.256-.155-.261a.141.141 0 00-.132.068 1.1 1.1 0 00-.115.261 1.024 1.024 0 01-.163.32.382.382 0 01-.333.133.42.42 0 01-.334-.168.557.557 0 01-.11-.374.605.605 0 01.383-.547l.138.27a.316.316 0 00-.219.292c-.007.129.055.211.148.216a.148.148 0 00.125-.055.984.984 0 00.111-.235l.042-.107a.893.893 0 01.043-.1.514.514 0 01.2-.239.432.432 0 01.227-.048.424.424 0 01.34.178.635.635 0 01.108.42.612.612 0 01-.422.602z"
      />
      <path
        className="fill"
        d="M908.31 241.614l.051-.305 1.561.26-.051.306-.647-.108-.1.58.647.108-.052.308-1.561-.26.052-.308.62.1.1-.58z"
      />
      <path className="fill" d="M908.637 240.139l.081-.3 1.528.412-.081.3z" />
      <path
        className="fill"
        d="M909.272 238.144a.531.531 0 01.278-.307.535.535 0 01.707.263.53.53 0 01.01.414l-.1.261.487.181-.109.292-1.483-.551zm.722.268a.24.24 0 00-.449-.167l-.1.261.449.167z"
      />
      <path className="fill" d="M910.579 235.343l.155-.27 1.371.789-.156.27z" />
      <path
        className="fill"
        d="M911.899 233.303l.182-.254 1.287.921-.138.193-1.181-.012.787.563-.182.254-1.287-.921.138-.193 1.18.01z"
      />
      <path
        className="fill"
        d="M914.951 231.759l.482-.461.206.216-.707.677-1.094-1.144.7-.669.206.216-.474.453.233.243.433-.414.2.212-.433.414z"
      />
      <path
        className="fill"
        d="M916.15 229.066l.249-.188.952 1.264-.19.143-1.124-.365.582.773-.249.188-.952-1.264.19-.143 1.122.363z"
      />
      <path
        className="fill"
        d="M918.334 229.147l.573-.341.152.256-.841.5-.809-1.36.831-.495.153.257-.563.335.172.289.515-.306.15.252-.515.306z"
      />
      <path
        className="fill"
        d="M920.704 228.252l-.518-.369-.216.1.227.5-.284.129-.654-1.441.576-.262a.515.515 0 01.609.806l.566.4zm-1.04-.946l.194.426.292-.133a.235.235 0 00-.193-.426z"
      />
      <path
        className="fill"
        d="M923.097 226.515l.036.116a.731.731 0 01-.045.589.772.772 0 01-.474.366.831.831 0 01-.651-.047.793.793 0 01-.4-.486.829.829 0 011.316-.885l-.209.226a.487.487 0 00-.47-.084.5.5 0 00-.313.253.547.547 0 00.222.71.537.537 0 00.418.022.439.439 0 00.352-.423l-.458.142-.081-.264z"
      />
      <path
        className="fill"
        d="M925.131 225.356l-.361 1.046.11.607-.3.055-.11-.607-.7-.853.347-.063.455.588.221-.711z"
      />
      <path
        className="fill"
        d="M928.961 226.664l-.25.139-.143-.158a.7.7 0 01-.427.131.619.619 0 01-.4-.131.43.43 0 01-.15-.346.515.515 0 01.27-.451.482.482 0 01-.074-.266.423.423 0 01.144-.326.5.5 0 01.356-.125.525.525 0 01.5.345l-.269.151a.239.239 0 00-.23-.193.172.172 0 00-.19.165c0 .084.037.143.126.241l.334.375a1.026 1.026 0 00.08-.261l.26.152a1.09 1.09 0 01-.142.331zm-.585-.229l-.337-.375v-.007a.242.242 0 00-.127.218c0 .129.088.216.257.218a.387.387 0 00.207-.054z"
      />
      <path
        className="fill"
        d="M931.587 226.783l.654.131-.058.293-.96-.192.31-1.552.948.19-.058.293-.643-.128-.066.33.588.117-.058.288-.587-.117z"
      />
      <path
        className="fill"
        d="M934.472 226.219l.3.1-.484 1.506-.226-.073-.35-1.129-.3.921-.3-.1.484-1.506.226.073.35 1.126z"
      />
      <path
        className="fill"
        d="M935.607 228.362l.18-1.659.308.142-.158 1.266.858-.944.31.143-1.146 1.214z"
      />
      <path
        className="fill"
        d="M938.032 227.825l.269.158-.8 1.365-.269-.158z"
      />
      <path
        className="fill"
        d="M939.095 230.412l.063-.632-.192-.139-.322.445-.253-.182.925-1.283.513.37a.525.525 0 01.12.733.515.515 0 01-.517.2l-.065.689zm.3-1.372l-.274.38.26.188a.235.235 0 00.274-.38z"
      />
      <path
        className="fill"
        d="M940.601 231.717a.81.81 0 01-.039-1.161.822.822 0 11.627 1.386.8.8 0 01-.588-.225zm.208-.223a.494.494 0 00.365.143.547.547 0 00.509-.545.525.525 0 00-.532-.5.547.547 0 00-.509.545.5.5 0 00.168.357z"
      />
      <path
        className="fill"
        d="M944.08 233.163l-1.228 1-.2-.24.8-.647-.851.118-.023-.028.287-.807-.794.646-.2-.242 1.227-1 .2.249-.294.824.865-.121z"
      />
      <path
        className="fill"
        d="M943.861 235.123l.355.565-.253.159-.521-.829 1.34-.842.515.819-.253.159-.349-.555-.285.179.319.507-.249.156-.319-.507z"
      />
      <path
        className="fill"
        d="M946.258 236.832l.135.281-1.427.684-.1-.214.579-1.03-.873.418-.135-.281 1.427-.684.1.214-.578 1.029z"
      />
      <path
        className="fill"
        d="M947.19 239.244l-.282.1-.139-.4-1.214.417-.1-.295 1.214-.417-.138-.4.282-.1z"
      />
      <path
        className="fill"
        d="M946.141 241.524l.257-.155-.139-.615-.3-.03-.074-.328 1.666.191.085.377-1.421.891zm.424-.738l.1.423.583-.354z"
      />
      <path
        className="fill"
        d="M946.677 243.025l.067.6-.3.033-.1-.91 1.573-.176.035.31z"
      />
      <path
        className="fill"
        d="M948.034 246.66a.718.718 0 01-.268.524.832.832 0 01-1.122-.084.719.719 0 01-.187-.558l.047-.627 1.578.117zm-1.28-.1a.438.438 0 00.111.344.5.5 0 00.347.155.493.493 0 00.363-.1.435.435 0 00.162-.323l.023-.316-.983-.073z"
      />
      <path
        className="fill"
        d="M946.491 248.621l-.126.655-.293-.056.184-.961 1.554.3-.182.95-.293-.056.124-.644-.331-.063-.112.588-.289-.055.113-.588z"
      />
      <path
        className="fill"
        d="M946.204 250.188l.071.3a.356.356 0 00-.338.277c-.051.166-.007.263.086.291a.141.141 0 00.145-.033 1.093 1.093 0 00.176-.225 1.021 1.021 0 01.237-.27.382.382 0 01.355-.047.42.42 0 01.282.245.555.555 0 01.015.39.605.605 0 01-.505.436l-.068-.3a.316.316 0 00.283-.23c.038-.123 0-.218-.09-.245a.147.147 0 00-.135.022.96.96 0 00-.165.2l-.067.093a.958.958 0 01-.066.086.471.471 0 01-.075.081.465.465 0 01-.178.1.428.428 0 01-.231-.01.423.423 0 01-.286-.255.635.635 0 010-.433.612.612 0 01.554-.473z"
      />
      <path
        className="fill"
        d="M946.633 252.714l-.119.289-1.464-.6.119-.289z"
      />
      <path
        className="fill"
        d="M944.639 255.129l-.107-.058a.731.731 0 01-.38-.452.775.775 0 01.082-.593.833.833 0 01.5-.422.794.794 0 01.627.067.829.829 0 01-.322 1.553l-.008-.308a.488.488 0 00.395-.269.5.5 0 00.047-.4.547.547 0 00-.655-.352.537.537 0 00-.314.277.437.437 0 00.045.549l.228-.422.243.131z"
      />
      <path
        className="fill"
        d="M944.115 257.201l-.183.253-1.283-.927.139-.192 1.182.017-.785-.567.182-.253 1.283.927-.139.192-1.18-.016z"
      />
    </g>
  </svg>
);

export const Buildings = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="23.344"
    viewBox="0 0 24 23.344"
    preserveAspectRatio="xMidYMid meet"
    style={{ marginBottom: 1 }}
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      d="M5 22.344H1v-10h4M9 15.344h2M9 18.344h2M9 12.344h2M13 5.344v-4l10 3v18H5v-14h10v14M19 18.344v-10"
    />
  </svg>
);

export const BuildingPlaceholder = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="35"
    viewBox="0 0 27 35"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="square">
      <path
        className="stroke"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11 14.025V5.006L26 1v33h-9.5"
      />
      <path className="stroke" d="M16 8v6" />
      <path className="stroke" strokeMiterlimit="10" d="M21 8v22" />
      <path className="stroke" strokeLinejoin="round" d="M1 18h15v16H1z" />
      <path className="stroke" strokeMiterlimit="10" d="M7 26h3" />
      <path className="stroke" strokeMiterlimit="10" d="M7 22h3" />
      <path className="stroke" strokeMiterlimit="10" d="M7 30h3" />
    </g>
  </svg>
);

export const BuildingDashboard = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="24"
    viewBox="0 0 16 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" strokeLinecap="round" d="M1 1h14v22H1z" />
    <path
      className="stroke"
      strokeLinecap="round"
      fillRule="evenodd"
      d="M5 5h1M10 5h1M5 9h1M10 9h1M5 13h1M10 13h1M5 17h1M10 17h1M8 23v-2"
    />
  </svg>
);

export const BuildingInformation = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22.09"
    viewBox="0 0 24 22.09"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      d="M4 14.099h8v7H4zM12 14.099h8v7h-8zM8 7.099h8v7H8zM1 6.099l11-5 11 5M12 7.099v2M16 14.099v2M8 14.099v2"
    />
  </svg>
);

export const Projects = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" strokeLinecap="round" d="M1 5h18v18H1zM5 1h10" />
  </svg>
);

export const ProjectsFilled = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M13 4H1a.945.945 0 0 0-1 1v10a.945.945 0 0 0 1 1h12a.945.945 0 0 0 1-1V5a.945.945 0 0 0-1-1z"
    />
    <path className="fill" d="M2 0h10v2H2z" />
  </svg>
);

export const Analytics = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" strokeLinecap="square" d="M1 1h22v22H1z" />
    <path className="stroke" strokeLinecap="square" d="M5 15l5-6 5 4 4-4" />
  </svg>
);

export const Mapping = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      d="M1 13h7M1 5h7M1 1v20h7M8 3h11v4H8zM8 19h11v4H8zM8 11h11v4H8z"
    />
  </svg>
);

export const DataQA = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="24"
    viewBox="0 0 22 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" strokeLinecap="square" d="M16 2h5v21H1V2h5" />
    <path
      className="stroke"
      strokeLinecap="square"
      d="M8 15l2 2 4-4M6 1v6h3a2 2 0 0 1 4 0h3V1z"
    />
  </svg>
);

export const ESGOverview = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="24"
    viewBox="0 0 22 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path className="stroke" d="M16 2h5v21H1V2h5" />
      <path className="stroke" d="M6 1v6h3a2 2 0 014 0h3V1z" />
      <path className="stroke" d="M6.5 12.5h9" />
      <path className="stroke" d="M6.5 16.5h9" />
    </g>
  </svg>
);

export const DataMapping = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <svg
      className={classnames("icon", className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      transform="matrix(.69 0 0 .69 15.5 15.5)"
    >
      <path
        className="fill"
        d="M37.1 23.7v55.2l22.5 4.7v-.3c0-2.9 0-4.7.1-8.7 0-4 .1-8.8.1-11.7 0-1.7 1.5-3.1 3.2-3.1 1.8 0 3.2 1.4 3.2 3.2 0 2.9 0 7.7-.1 11.7 0 4-.1 5.8-.1 8.7v.3L88.6 79V23.7l-1.8.9c-1.6.8-3.5.1-4.3-1.4-.8-1.6-.1-3.5 1.4-4.2l6.4-3.2c1.4-.7 3-.3 3.9.8.5.6.8 1.3.8 2.1v62.1c0 1.9-1.3 3.5-3.2 3.9l-28.1 5.9c-.5.1-1.1.1-1.6 0L35.5 85c-.3.2-.6.3-.9.3l-25.7 5c-1.7.3-3.4-.8-3.8-2.5-.1-.1-.1-.3-.1-.5v-63c0-1.5 1-2.7 2.5-3.1l25.7-5.8c1-.2 2 0 2.8.6l5.8 2.9c1.6.8 2.2 2.7 1.4 4.2-.8 1.6-2.7 2.2-4.3 1.4l-1.8-.8zM11.4 83.4l19.3-3.8V22.5l-19.3 4.3v56.6z"
      />
      <path
        className="fill"
        d="M62.8 14.7c6 0 10.9 4.7 10.9 10.6 0 5.7-5.6 14.7-10.9 21.4C57.6 39.9 52 30.9 52 25.3c0-5.8 4.8-10.6 10.8-10.6m0-6C53.5 8.7 46 16.1 46 25.3 46 37.7 62.8 56 62.8 56s16.9-18.3 16.9-30.7c0-9.2-7.6-16.6-16.9-16.6z"
      />
      <ellipse
        className="fill"
        cx="62.8"
        cy="25.3"
        rx="6"
        ry="5.9"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  </svg>
);

export const InvestmentDecisionLab = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    style={{ marginTop: 1 }}
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M1 5h22"
    />
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M1 10h22"
    />
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M23 10V3a2.006 2.006 0 0 0-2-2H3a2.006 2.006 0 0 0-2 2v13a2.006 2.006 0 0 0 2 2h6"
    />
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M16 23h-3v-3l6-6 3 3z"
    />
  </svg>
);

export const Performance = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    preserveAspectRatio="xMidYMid meet"
    style={{ marginLeft: 2, marginBottom: 2 }}
    {...props}
  >
    <g strokeMiterlimit={10}>
      <path className="stroke" d="M15.6 17.5A8 8 0 1 1 9 5" />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M18.9 19.8A12.158 12.158 0 0 0 21 13 12.035 12.035 0 0 0 9 1v12z"
      />
    </g>
  </svg>
);

export const Monitoring = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    preserveAspectRatio="xMidYMid meet"
    style={{ marginTop: 1 }}
    {...props}
  >
    <g transform="translate(-1)" strokeLinecap="square">
      <path className="stroke" d="M19 14v8H2V5h8" />
      <circle
        className="stroke"
        cx="4"
        cy="4"
        r="4"
        transform="translate(15 1)"
      />
    </g>
  </svg>
);

export const Reporting = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" d="M19 17h-6v6" />
    <path className="stroke" strokeLinecap="square" d="M19 17V1H1v22h12z" />
    <path className="stroke" strokeLinecap="square" d="M9 17H5" />
    <path className="stroke" strokeLinecap="square" d="M15 12H5" />
    <path className="stroke" strokeLinecap="square" d="M15 7H5" />
  </svg>
);

export const Search = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16.1"
    viewBox="0 0 16 16.1"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M12.7 11.3a6.847 6.847 0 0 0 1.4-4.2 7.042 7.042 0 0 0-7-7.1 7.1 7.1 0 0 0 0 14.2 6.64 6.64 0 0 0 4.2-1.4l3 3a.967.967 0 0 0 1.4 0 .967.967 0 0 0 0-1.4zm-5.6.8a5.037 5.037 0 0 1-5.1-5 5.1 5.1 0 0 1 10.2 0 5.037 5.037 0 0 1-5.1 5z"
    />
  </svg>
);

export const Delete = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M16 5V3h-4V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2H0v2zM6 2h4v1H6zM13 7v7H3V7H1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
    />
  </svg>
);

export const Duplicate = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path d="M9 4H1a.945.945 0 0 0-1 1v10a.945.945 0 0 0 1 1h8a.945.945 0 0 0 1-1V5a.945.945 0 0 0-1-1z" />
    <path
      className="fill"
      d="M2 6v8h6V6H2M1 4h8c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1z"
    />
    <path className="fill" d="M13 0H3v2h9v11h2V1a.945.945 0 0 0-1-1z" />
  </svg>
);

export const Copy = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path className="stroke" d="M6 5h6v7H6z" />
      <path className="stroke" d="M9 3V1H1v10h3" />
    </g>
  </svg>
);

export const Download = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M7 12a.908.908 0 0 0 .7-.3L13.4 6 12 4.6l-4 4V0H6v8.6l-4-4L.6 6l5.7 5.7a.908.908 0 0 0 .7.3zM0 14h14v2H0z"
    />
  </svg>
);

export const Plus = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="8.094"
    height="8.094"
    viewBox="0 0 8.094 8.094"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      strokeMiterlimit={10}
      strokeLinecap="square"
      className="stroke"
      d="M4.047 1v6.094M7.094 4.047H1"
    />
  </svg>
);

export const Minus = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="8.094"
    height="2"
    viewBox="0 0 8.094 2"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      strokeMiterlimit={10}
      strokeLinecap="square"
      className="stroke"
      d="M7.094 1H1"
    />
  </svg>
);

export const Save = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <svg
      className={classnames("icon", className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      transform="matrix(.69 0 0 .69 15.5 15.5)"
    >
      <path
        className="fill"
        d="M90.4 5H5v90h83.5c3.6 0 6.5-2.9 6.5-6.5V9.6L90.4 5zM28.8 8.5h43.5v29.2c0 2.8-2.2 5-5 5H33.8c-2.8 0-5-2.2-5-5V8.5zm52.1 78.8c0 1.8-1.4 3.2-3.2 3.2H22.3c-1.8 0-3.2-1.4-3.2-3.2V48.7c0-1.8 1.4-3.2 3.2-3.2h55.4c1.8 0 3.2 1.4 3.2 3.2v38.6zM65.2 38.1H53v-27h12.2v27z"
      />
    </svg>
  </svg>
);

export const Caret = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10.828"
    height="6.828"
    viewBox="0 0 10.828 6.828"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M1.414 5.414l4-4 4 4"
    />
  </svg>
);

export const LinePlot = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="round"
      d="M1 1v32h32M1 1h4M33 28.666v4"
    />
    <path
      className="stroke"
      strokeMiterlimit={10}
      strokeLinecap="round"
      d="M1 23.682l7.453-9.86 4.956 6.556 7.668-9.262 5.277 6.974L33 9.305"
    />
  </svg>
);

export const BarPlot = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="round"
      d="M1 1v32h32M1 1h4M33 29v4"
    />
    <path className="stroke" strokeLinejoin="round" d="M1 21h8v12H1z" />
    <path
      className="stroke"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M9 8h8v25H9z"
    />
    <path className="stroke" strokeLinejoin="round" d="M17 16h8v17h-8z" />
  </svg>
);

export const ScatterPlot = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(1.25 2)">
      <path
        className="stroke"
        strokeLinecap="round"
        d="M-.25-1v32h32M-.25-1h4M31.75 27v4"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(7.75 8)"
      />
      <rect
        className="fill"
        width="2"
        height="6"
        rx="1"
        transform="translate(7.75 12)"
      />
      <rect
        className="fill"
        width="2"
        height="13"
        rx="1"
        transform="translate(19.75 7)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(15.75 6)"
      />
      <rect
        className="fill"
        width="2"
        height="4"
        rx="1"
        transform="translate(3.75 12)"
      />
      <rect
        className="fill"
        width="2"
        height="8"
        rx="1"
        transform="translate(23.75 8)"
      />
      <rect
        className="fill"
        width="2"
        height="8"
        rx="1"
        transform="translate(11.75 14)"
      />
      <rect
        className="fill"
        width="2"
        height="8"
        rx="1"
        transform="translate(15.75 10)"
      />
      <rect
        className="fill"
        width="2"
        height="4"
        rx="1"
        transform="translate(27.75 14)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(23.75 18)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(27.75 10)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(23.75 4)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(19.75 22)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(19.75 2)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(3.75 18)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(7.75 20)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(15.75 20)"
      />
      <rect
        className="fill"
        width="2"
        height="2"
        rx="1"
        transform="translate(11.75 24)"
      />
    </g>
  </svg>
);

export const HistogramPlot = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="round"
      d="M1 1v32h32M1 1h4M33 29v4"
    />
    <path className="stroke" strokeLinejoin="round" d="M13 9v8H1V9z" />
    <path
      className="stroke"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M26 17v8H1v-8z"
    />
    <path className="stroke" strokeLinejoin="round" d="M18 25v8H1v-8z" />
  </svg>
);

export const Clear = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="7.828"
    height="7.828"
    viewBox="0 0 7.828 7.828"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="square" strokeMiterlimit={10}>
      <path className="stroke" d="M6.414 1.414l-5 5" />
      <path className="stroke" d="M6.414 6.414l-5-5" />
    </g>
  </svg>
);

export const Close = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.7.3a.967.967 0 0 0-1.4 0L7 5.6 1.7.3A.967.967 0 0 0 .3.3a.967.967 0 0 0 0 1.4L5.6 7 .3 12.3a.967.967 0 0 0 0 1.4.908.908 0 0 0 .7.3.908.908 0 0 0 .7-.3L7 8.4l5.3 5.3a.967.967 0 0 0 1.4 0 .967.967 0 0 0 0-1.4L8.4 7l5.3-5.3a.967.967 0 0 0 0-1.4z"
    />
  </svg>
);

export const Check = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="9.413"
    height="7.049"
    viewBox="0 0 9.413 7.049"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M1.415 3.27l2.364 2.365M8 1.414l-4.22 4.22"
    />
  </svg>
);

export const ClearChart = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.682"
    height="17.184"
    viewBox="0 0 16.682 17.184"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M1 2.184v14h13M11.732 1.416l3.536 3.536M15.268 1.416l-3.536 3.536"
      strokeLinecap="square"
      strokeMiterlimit={10}
    />
    <path
      className="stroke"
      d="M3.42 10.86l2.056-2.056L9.9 13.23l4.426-4.426"
    />
  </svg>
);

export const Gear = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M23 12a2 2 0 0 0-2-2h-1.262a7.968 7.968 0 0 0-.852-2.058l.892-.892a2 2 0 1 0-2.828-2.828l-.892.892A7.968 7.968 0 0 0 14 4.262V3a2 2 0 0 0-4 0v1.262a7.968 7.968 0 0 0-2.058.852l-.892-.892A2 2 0 0 0 4.222 7.05l.892.892A7.968 7.968 0 0 0 4.262 10H3a2 2 0 0 0 0 4h1.262a7.968 7.968 0 0 0 .852 2.058l-.892.892a2 2 0 0 0 2.828 2.828l.892-.892a7.953 7.953 0 0 0 2.058.852V21a2 2 0 0 0 4 0v-1.262a7.968 7.968 0 0 0 2.058-.852l.892.892a2 2 0 1 0 2.828-2.828l-.892-.892A7.953 7.953 0 0 0 19.738 14H21a2 2 0 0 0 2-2z"
      strokeLinecap="square"
    />
    <circle
      className="stroke"
      cx="3"
      cy="3"
      r="3"
      transform="translate(9 9)"
      strokeLinecap="square"
    />
  </svg>
);

export const Dot = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="fill" d="M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z" />
  </svg>
);

export const FolderCloud = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M23 23H1V1h8l3 4h11z"
      strokeLinecap="square"
      strokeMiterlimit={10}
    />
    <path
      className="stroke"
      d="M13.5 10a3.542 3.542 0 0 0-3.2 2.1c-.3 0-.5-.1-.8-.1a2.5 2.5 0 0 0 0 5h4a3.5 3.5 0 0 0 0-7z"
      strokeLinecap="square"
      strokeMiterlimit={10}
    />
  </svg>
);

export const NewProject = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path className="stroke" d="M1 5h18v18H1z" />
      <path className="stroke" d="M5 1h10" />
      <path className="stroke" d="M7 14h6" />
      <path className="stroke" d="M10 11v6" />
    </g>
  </svg>
);

export const LightBulb = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="11.818"
    height="15.5"
    viewBox="0 0 11.818 15.5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="square" strokeMiterlimit="10">
      <path
        className="stroke"
        d="M10.818 5.917a4.909 4.909 0 1 0-6.75 4.556v.318H7.75v-.318a4.915 4.915 0 0 0 3.068-4.556z"
      />
      <path className="stroke" d="M7.742 12.056V14.5H4.076v-2.444" />
      <path className="stroke" d="M4.462 6.173a1.712 1.712 0 0 1 1.712-1.712" />
    </g>
  </svg>
);

export const WaterDroplet = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="15.714"
    height="20"
    viewBox="0 0 15.714 20"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M1 12.143C1 7.943 7.857 1 7.857 1s6.857 6.943 6.857 11.143A6.757 6.757 0 0 1 7.857 19 6.757 6.757 0 0 1 1 12.143zM7.857 14.714a2.571 2.571 0 0 1-2.571-2.571"
    />
  </svg>
);

export const Computer = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.5"
    height="12.375"
    viewBox="0 0 16.5 12.375"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15.469 9.281V2.063A2.022 2.022 0 0 0 13.406 0H3.094a2.022 2.022 0 0 0-2.063 2.063v7.219H0v1.031a2.062 2.062 0 0 0 2.063 2.063h12.375a2.062 2.062 0 0 0 2.062-2.063V9.281zM3.094 2.063h10.312v7.219H3.094z"
    />
  </svg>
);

export const ComputerLarge = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    {...props}
  >
    <path
      d="M46.6667 38.6491H3.33333C2.71449 38.6491 2.121 38.4033 1.68342 37.9657C1.24583 37.5281 1 36.9346 1 36.3158V6.31576C1 5.69692 1.24583 5.10342 1.68342 4.66584C2.121 4.22825 2.71449 3.98242 3.33333 3.98242H46.6667C47.2855 3.98242 47.879 4.22825 48.3166 4.66584C48.7542 5.10342 49 5.69692 49 6.31576V36.3158C49 36.9346 48.7542 37.5281 48.3166 37.9657C47.879 38.4033 47.2855 38.6491 46.6667 38.6491Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M3.33333 39.6494H46.6667C47.5507 39.6494 48.3986 39.2983 49.0237 38.6731C49.6488 38.048 50 37.2002 50 36.3161V30.5469H0V36.3161C0 37.2002 0.35119 38.048 0.976311 38.6731C1.60143 39.2983 2.44928 39.6494 3.33333 39.6494Z"
      className="fill"
    />
    <path
      d="M30 43.8164V47.9831"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M20 47.9831V43.8164"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.333 47.9824H36.6663"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M23.333 8.81641H26.6663"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const LightningBolt = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="15.5"
    height="15.5"
    viewBox="0 0 15.5 15.5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M8.5 1L1 9.25h6.75L7 14.5l7.5-8.25H7.75z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);

export const LightningBoltLarge = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    {...props}
  >
    <path
      d="M30.5004 0.982422L3.65039 31.5374H23.0954L19.3904 50.9824L46.2404 20.4274H26.8004L30.5004 0.982422Z"
      className="fill"
    />
    <path
      d="M29.2705 7.45312C31.9601 8.06873 34.4836 9.26182 36.6662 10.9497C38.8488 12.6376 40.6382 14.7799 41.9105 17.2281"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.22578 28.6081C5.56719 23.8941 6.70195 19.1045 9.40556 15.1871C12.1092 11.2696 16.1847 8.50962 20.8258 7.45312"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6303 44.4812C17.9848 43.8469 15.506 42.6529 13.361 40.9796C11.2159 39.3064 9.45448 37.1928 8.19531 34.7812"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.835 23.1621C43.976 24.0955 44.0462 25.0382 44.045 25.9821C44.0428 30.2739 42.5878 34.4385 39.9167 37.7978C37.2456 41.1571 33.5159 43.5131 29.335 44.4821"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Fan = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.786"
    height="15.846"
    viewBox="0 0 16.786 15.846"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeMiterlimit="10">
      <path
        className="stroke"
        d="M1.365 13.216l6.967-4.024a4.115 4.115 0 0 0-5.2-.9 4.052 4.052 0 0 0-1.766 4.92z"
      />
      <path
        className="stroke"
        d="M15.261 13.215L8.295 9.193a4.115 4.115 0 0 0 1.824 4.951 4.052 4.052 0 0 0 5.142-.929z"
      />
      <path
        className="stroke"
        d="M8.307 1.184v8.044a4.115 4.115 0 0 0 3.377-4.052 4.052 4.052 0 0 0-3.377-3.992z"
      />
    </g>
  </svg>
);

export const HeatRejection = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="13.095"
    height="15.5"
    viewBox="0 0 13.095 15.5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path
        className="stroke"
        d="M1 14.5l1.958-5.7V5.031h7.179v3.767l1.958 5.7z"
        strokeLinejoin="round"
      />
      <path className="stroke" d="M3.501 1h6.163" />
    </g>
  </svg>
);

export const Flame = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12.65"
    height="15.5"
    viewBox="0 0 12.65 15.5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M7.787 6.31S8.416 2.61 5.848 1a4.533 4.533 0 0 1-1.709 3.28C3.042 5.245.978 7.41 1 9.725A5.307 5.307 0 0 0 3.911 14.5a3.363 3.363 0 0 1 1.176-2.324 2.742 2.742 0 0 0 1.051-1.844 4.941 4.941 0 0 1 2.617 4.119v.014a4.965 4.965 0 0 0 2.89-4.308A7.715 7.715 0 0 0 9.871 5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);

export const Pump = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="17.656"
    height="13.5"
    viewBox="0 0 17.656 13.5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M9.026 11.5l.169-.013a4.737 4.737 0 0 0 3.111-1.503 4.74 4.74 0 0 0 1.26-3.605L13.4 4.227h2.255V2H8.609l-.149.011C6.002 2.2 4.077 4.28 4.077 6.745c0 .126.005.247.014.369l.168 2.155H2V11.5h7.026m.322 2H0V7.27h2.097a6.692 6.692 0 0 1-.02-.525c0-3.546 2.748-6.461 6.23-6.728V0h9.349v6.227H15.56a6.755 6.755 0 0 1-6.211 7.254v.019z"
    />
    <g transform="translate(5.435 3.502)">
      <rect
        className="fill"
        width="6.571"
        height="2.19"
        rx="1.095"
        transform="rotate(45 .774 1.87)"
      />
      <rect
        className="fill"
        width="6.571"
        height="2.19"
        rx="1.095"
        transform="rotate(135 2.777 2.058)"
      />
    </g>
  </svg>
);

export const Edit = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M12.7.3a.967.967 0 0 0-1.4 0l-7 7A.908.908 0 0 0 4 8v3a.945.945 0 0 0 1 1h3a.908.908 0 0 0 .7-.3l7-7a.967.967 0 0 0 0-1.4zM7.6 10H6V8.4l6-6L13.6 4z"
    />
    <path
      className="fill"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M15 10a.945.945 0 0 0-1 1v3H2V2h3a.945.945 0 0 0 1-1 .945.945 0 0 0-1-1H1a.945.945 0 0 0-1 1v14a.945.945 0 0 0 1 1h14a.945.945 0 0 0 1-1v-4a.945.945 0 0 0-1-1z"
    />
  </svg>
);

export const EditAlt = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M9,10H2V3H4V1H1A1,1,0,0,0,0,2v9a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V8H9Z"
    />
    <path
      className="fill"
      d="M11.581.413a1.409,1.409,0,0,0-1.994,0L5,5,4,8,7,7l4.587-4.587a1.409,1.409,0,0,0,0-1.994Z"
    />
  </svg>
);

export const WaterFaucet = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="19.055"
    height="19.055"
    viewBox="0 0 19.055 19.055"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M14.039 16.02c0-1.255 1.98-3.3 1.98-3.3s1.98 2.046 1.98 3.3a1.98 1.98 0 1 1-3.961 0z"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    />
    <path
      className="stroke"
      d="M1 9.431A8.5 8.5 0 0 1 18 9.5h-4.638a3.862 3.862 0 0 0-7.723-.069V18H1V9.431z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
    />
    <path className="stroke" d="M1 13.7h4.844" />
  </svg>
);

export const Grouping = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M7 8H1a.945.945 0 0 0-1 1v6a.945.945 0 0 0 1 1h6a.945.945 0 0 0 1-1V9a.945.945 0 0 0-1-1z"
    />
    <path className="fill" d="M11 4H2v2h8v8h2V5a.945.945 0 0 0-1-1z" />
    <path className="fill" d="M15 0H6v2h8v8h2V1a.945.945 0 0 0-1-1z" />
  </svg>
);

export const Link = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.1"
    height="16"
    viewBox="0 0 16.1 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M4.5,16a4.816,4.816,0,0,1-3.2-1.3,4.468,4.468,0,0,1,0-6.4L2,7.6,3.4,9l-.7.7a2.546,2.546,0,0,0,3.6,3.6l3-3a2.535,2.535,0,0,0,0-3.6L8.6,6,10,4.6l.7.7a4.468,4.468,0,0,1,0,6.4l-3,3A4.626,4.626,0,0,1,4.5,16Z"
      transform="translate(.05)"
    />
    <path
      className="fill"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M6,11.4l-.7-.7a4.468,4.468,0,0,1,0-6.4l3-3A4.377,4.377,0,0,1,11.5,0a4.816,4.816,0,0,1,3.2,1.3,4.468,4.468,0,0,1,0,6.4l-.7.7L12.6,7l.7-.7A2.546,2.546,0,0,0,9.7,2.7l-3,3a2.535,2.535,0,0,0,0,3.6l.7.7Z"
      transform="translate(.05)"
    />
  </svg>
);

export const Attach = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14.575"
    height="16.15"
    viewBox="0 0 14.575 16.15"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M9.6,12.8a3.984,3.984,0,0,1-5.7,0,3.753,3.753,0,0,1-.1-5.5L8.3,2.8a2.416,2.416,0,0,1,3.5,0,2.416,2.416,0,0,1,0,3.5L8.3,9.9A.99.99,0,0,1,6.9,8.5L9.7,5.7,8.2,4.3,5.5,7a2.9,2.9,0,0,0,0,4.2,2.987,2.987,0,0,0,4.2,0l3.6-3.6a4.468,4.468,0,0,0,0-6.4,4.468,4.468,0,0,0-6.4,0L2.4,5.9a5.855,5.855,0,0,0,.1,8.3A5.978,5.978,0,0,0,6.8,16,5.6,5.6,0,0,0,11,14.2l4.3-4.3L13.9,8.5Z"
      transform="translate(-.724 .15)"
    />
  </svg>
);

export const Systems = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="13"
    viewBox="0 0 15 13"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M13 12H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4a1 1 0 0 1 .707.293l2 2A1 1 0 0 1 14 5v6a1 1 0 0 1-1 1z"
    />
    <path
      className="fill"
      d="M1 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4V6H2V1a1 1 0 0 0-1-1z"
    />
  </svg>
);

export const Elements = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 5h-2.2A6.486 6.486 0 0 0 0 6.5a6.435 6.435 0 0 0 5 6.3V15a.945.945 0 0 0 1 1h9a.945.945 0 0 0 1-1V6a.945.945 0 0 0-1-1zM2 6.5A4.475 4.475 0 0 1 10.7 5H6a.945.945 0 0 0-1 1v4.7a4.452 4.452 0 0 1-3-4.2zm8.9.5A4.366 4.366 0 0 1 7 10.9V7zm3.1 7H7v-1a6.535 6.535 0 0 0 6-6h1z"
    />
  </svg>
);

export const Note = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 1h-3v2h2v11H2V3h2V1H1a.945.945 0 0 0-1 1v13a.945.945 0 0 0 1 1h14a.945.945 0 0 0 1-1V2a.945.945 0 0 0-1-1z"
    />
    <path className="fill" d="M5 0h6v4H5z" />
    <path className="fill" d="M4 6h8v2H4z" />
    <path className="fill" d="M4 10h8v2H4z" />
  </svg>
);

export const Pin = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16.014"
    viewBox="0 0 14 16.014"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(-1)">
      <circle className="fill" cx="2" cy="2" r="2" transform="translate(6 5)" />
      <path
        className="fill"
        d="M7.3 15.7c-.1-.1-4.2-3.7-4.2-3.8A6.355 6.355 0 0 1 1 7a6.957 6.957 0 0 1 7-7 6.957 6.957 0 0 1 7 7 6.722 6.722 0 0 1-2.1 5c-.1.1-4.1 3.7-4.2 3.8a1.071 1.071 0 0 1-1.4-.1zm-2.7-5l3.4 3 3.4-3A5.008 5.008 0 0 0 13 7.1a4.951 4.951 0 0 0-5-5A4.868 4.868 0 0 0 3 7a5.233 5.233 0 0 0 1.6 3.7z"
      />
    </g>
  </svg>
);

export const Resize = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="10"
    viewBox="0 0 16 10"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="fill" d="M0 0h2v10H0z" />
    <path className="fill" d="M14 0h2v10h-2z" />
    <path
      className="stroke"
      d="M9.562 8.034l2.455-3.017L9.562 2"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M6.456 2L4.001 5.017l2.455 3.017"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cloud = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="10"
    viewBox="0 0 16 10"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M12.5 10h-9A3.543 3.543 0 0 1 0 6.5 3.458 3.458 0 0 1 3.4 3a5.027 5.027 0 0 1 9.2 0A3.458 3.458 0 0 1 16 6.5a3.543 3.543 0 0 1-3.5 3.5zm-9-5a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3 7.006 7.006 0 0 0-1.4.3C10.9 4.3 10.6 2 8 2S5.1 4.3 4.9 5.3A7.006 7.006 0 0 0 3.5 5z"
    />
  </svg>
);

export const Ellipse = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20.998"
    height="5"
    viewBox="0 0 20.998 5"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M16.001 2.5a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-2.5 2.5 2.5 2.5 0 0 1-2.5-2.5zm-8 0a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-2.5 2.5 2.5 2.5 0 0 1-2.5-2.5zm-8 0a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-2.5 2.5 2.5 2.5 0 0 1-2.5-2.5z"
      className="fill"
    />
  </svg>
);

export const Upload = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M7 3.4V12h2V3.4l4 4L14.4 6 8.7.3a.967.967 0 0 0-1.4 0L1.6 6 3 7.4z"
    />
    <path
      className="fill"
      d="M14 14H2v-3H0v4a.945.945 0 0 0 1 1h14a.945.945 0 0 0 1-1v-4h-2z"
    />
  </svg>
);

export const DateUpload = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="stroke"
      d="M4 12L2.5 12C2.10217 12 1.72064 11.842 1.43934 11.5607C1.15803 11.2794 0.999999 10.8978 0.999999 10.5L0.999999 4.5C0.999999 4.10218 1.15803 3.72064 1.43934 3.43934C1.72064 3.15804 2.10217 3 2.5 3L10.5 3C10.8978 3 11.2794 3.15804 11.5607 3.43934C11.842 3.72065 12 4.10218 12 4.5L12 10.5C12 10.8978 11.842 11.2794 11.5607 11.5607C11.2794 11.842 10.8978 12 10.5 12L9 12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M4.5 9L6.5 7L8.5 9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M6.5 12L6.5 8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="fill"
      d="M1 4C1 3.44772 1.44772 3 2 3H11C11.5523 3 12 3.44772 12 4V5H1V4Z"
    />
    <path
      className="stroke"
      d="M4 3L4 1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M9 3L9 1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdminLogo = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M16 9V7l-2.3-.8a4.179 4.179 0 0 0-.4-1l1.1-2.1L13 1.7l-2.1 1.1a3.582 3.582 0 0 0-1.1-.4L9 0H7l-.8 2.3a4.179 4.179 0 0 0-1 .4L3.1 1.6 1.6 3.1l1.1 2.1a4.179 4.179 0 0 0-.4 1L0 7v2l2.3.8c.1.4.3.7.4 1.1L1.6 13 3 14.4l2.1-1.1a3.582 3.582 0 0 0 1.1.4L7 16h2l.8-2.3c.4-.1.7-.3 1.1-.4l2.1 1.1 1.4-1.4-1.1-2.1a3.582 3.582 0 0 0 .4-1.1zm-7-.277V11H7V8.723a2 2 0 1 1 2 0z"
    />
  </svg>
);

export const BuildingDataModel = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" d="M1 1h20v20H1zM11 1v20" strokeMiterlimit="10" />
    <path
      className="stroke"
      d="M5 5h2M15 5h2M5 9h2M15 9h2M5 13h2M15 13h2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const SensorsAndIntegrations = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M8 3V1M16 3V1M12 3V1M23 16h-2M23 8h-2M23 12h-2M3 16H1M3 8H1M3 12H1M8 23v-2M16 23v-2M12 23v-2"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <rect
      className="stroke"
      width="18"
      height="18"
      rx="2"
      transform="translate(3 3)"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      className="stroke"
      d="M7 7h10v10H7z"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
  </svg>
);
export const UsersAndAccounts = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="23"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M16.667 15H23v-3.94a1.948 1.948 0 0 0-.947-1.672l-2.825-1.7"
      strokeMiterlimit="10"
    />
    <path
      className="stroke"
      d="M13.248 3.2A3.5 3.5 0 0 1 16.5 1 3.5 3.5 0 0 1 20 4.5v1A3.5 3.5 0 0 1 16.5 9a3.367 3.367 0 0 1-1.5-.344M6.858 12.89l-4.547 2.724A2.7 2.7 0 0 0 1 17.929V22h18v-4.071a2.7 2.7 0 0 0-1.311-2.315l-4.547-2.724"
      strokeMiterlimit="10"
    />
    <path
      className="stroke"
      d="M10 14a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5 5 5 0 0 1 5 5v2a5 5 0 0 1-5 5z"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
  </svg>
);

export const Hyperlink = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12.002"
    height="11.969"
    viewBox="0 0 12.002 11.969"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <defs />
    <path
      className="fill"
      d="M6.249.947L4.731 2.428a.75.75 0 1 0 1.046 1.075l1.527-1.488a1.875 1.875 0 1 1 2.644 2.658L8.467 6.192a.75.75 0 1 0 1.074 1.047l1.475-1.512a3.381 3.381 0 0 0 0-4.773A3.462 3.462 0 0 0 6.249.947zM6.231 8.428L4.704 9.917A1.875 1.875 0 1 1 2.06 7.258l1.481-1.519a.75.75 0 1 0-1.074-1.047L.992 6.204a3.375 3.375 0 1 0 4.767 4.778l1.518-1.479a.75.75 0 1 0-1.046-1.075z"
    />
    <path
      className="fill"
      d="M3.474 8.496a.748.748 0 0 0 1.06 0l4-4a.75.75 0 1 0-1.06-1.061l-4 4a.75.75 0 0 0 0 1.061z"
    />
  </svg>
);

export const Refresh = ({
  className,
  title,
  ...props
}: ComponentProps<"svg"> & { title?: string }) => (
  <svg
    className={classnames("icon", className)}
    width="12.001"
    height="12"
    viewBox="0 0 12.001 12"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    {title && <title>{title}</title>}
    <path
      className="fill"
      d="M12.001 5.639V0L10.23 1.752A5.937 5.937 0 0 0 6.001 0a6 6 0 1 0 4.8 9.6l-1.6-1.2a4 4 0 1 1-3.2-6.4 3.944 3.944 0 0 1 2.794 1.171l-1.919 1.9z"
    />
  </svg>
);

export const Category = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M11 6H1a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2zM11 2H7a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zM5 10H1a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z"
    />
  </svg>
);

export const SideArrow = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="5"
    height="8"
    viewBox="0 0 5 8"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path d="M0 0v8l5-4z" className="fill" />
  </svg>
);

export const Camera = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 3h-2.5L10.8.4A1.234 1.234 0 0 0 10 0H6a1.234 1.234 0 0 0-.8.4L3.5 3H1a.945.945 0 0 0-1 1v11a.945.945 0 0 0 1 1h14a.945.945 0 0 0 1-1V4a.945.945 0 0 0-1-1zm-1 11H2V5h2a1.234 1.234 0 0 0 .8-.4L6.5 2h2.9l1.7 2.6a1.8 1.8 0 0 0 .9.4h2z"
    />
    <circle className="fill" cx="3" cy="3" r="3" transform="translate(5 6)" />
  </svg>
);

export const ContactCameraOutlined = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    {...props}
  >
    <path
      d="M1 21h22V4H1v17ZM4 1h4"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M15 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M6 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" className="fill" />
  </svg>
);

export const ContactCameraFilled = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.5 2h-9A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 10.5 2Zm-3 7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM6 0H2v1h4V0Z"
      className="fill"
    />
  </svg>
);

export const Spreadsheet = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M1 16h14a.945.945 0 0 0 1-1V1a.945.945 0 0 0-1-1H1a.945.945 0 0 0-1 1v14a.945.945 0 0 0 1 1zm1-7h5v5H2zm7 5V9h5v5zm5-7H9V2h5zM7 2v5H2V2z"
    />
  </svg>
);

export const List = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 0a.946.946 0 0 1 1 1v14a.947.947 0 0 1-1 1H1a.947.947 0 0 1-1-1V1a.947.947 0 0 1 1-1zm-1 2H2v2h12zM2 6v4h12V6zm0 6v2h12v-2z"
    />
  </svg>
);

export const Calculator = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="24"
    viewBox="0 0 21 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" d="M1 1h19v22H1z" />
    <path
      className="stroke"
      d="M5 6h11v4H5zM5 14h1M10 14h1M5 18h1M10 18h1M15 14h1M15 18h1"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ValidThin = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M6 12l4 4 8-8"
    />
    <circle
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit={10}
      cx="11"
      cy="11"
      r="11"
      transform="translate(1 1)"
    />
  </svg>
);

export const Hamburger = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="square" strokeMiterlimit="10">
      <path className="stroke" d="M11 1H1" />
      <path className="stroke" d="M11 5H1" />
      <path className="stroke" d="M11 9H1" />
    </g>
  </svg>
);

export const SystemIcon = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      fill="none"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 1h4v4H1zM9 1h4v4H9zM17 1h4v4h-4zM25 1h4v4h-4zM1 9h4v4H1zM9 9h4v4H9zM17 9h4v4h-4zM25 9h4v4h-4zM1 17h4v4H1zM9 17h4v4H9zM17 17h4v4h-4zM25 17h4v4h-4zM1 25h4v4H1zM9 25h4v4H9zM17 25h4v4h-4zM25 25h4v4h-4z"
    />
  </svg>
);

export const Undo = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22.546"
    viewBox="0 0 22 22.546"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeMiterlimit="10">
      <path
        className="stroke"
        d="M21 11.525a10.029 10.029 0 0 0-10-10 9.836 9.836 0 0 0-8.9 5.5"
      />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M1.3 1.125l.8 5.9 6-.8"
      />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M18.26 18.41a9.663 9.663 0 0 0 1.64-2.385"
      />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M11.25 21.525a10.044 10.044 0 0 0 3.2-.6"
      />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M3.866 18.515a10.09 10.09 0 0 0 2.695 1.964"
      />
      <path
        className="stroke"
        strokeLinecap="square"
        d="M1 11.525a9.92 9.92 0 0 0 .461 2.994"
      />
    </g>
  </svg>
);

export const Logout = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="23.414"
    height="18"
    viewBox="0 0 23.414 18"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path d="M4.414 12l-3-3 3-3" className="stroke" />
    <path
      className="stroke"
      d="M7.514 13a7.99 7.99 0 106.9-12 7.9 7.9 0 00-6.9 4M15.414 9h-14"
    />
  </svg>
);

export const EmailNotification = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(2 4.08)" strokeLinecap="square">
      <path className="stroke" d="M.027.814l6.226 5.66 4.045-3.425" />
      <path className="stroke" d="M14.003 6.803v4.121h-15v-11h9.93" />
      <circle
        className="stroke"
        cx="3"
        cy="3"
        r="3"
        transform="translate(9 -3.08)"
      />
    </g>
  </svg>
);

export const Lock = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      className="fill"
      d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    />
  </svg>
);

export const Schedule = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.146"
    height="16"
    viewBox="0 0 16.146 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path className="stroke" d="M1 7h14" />
      <path
        className="stroke"
        d="M14.2 2.74H1.943A.943.943 0 001 3.683v10.374a.943.943 0 00.943.943H14.2a.943.943 0 00.943-.943V3.683a.943.943 0 00-.943-.943z"
      />
      <path className="stroke" d="M5 1v1" />
      <path className="stroke" d="M11 1v1" />
    </g>
  </svg>
);

export const Power = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12.679"
    height="18"
    viewBox="0 0 12.679 18"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g>
      <path
        className="stroke"
        d="M7.852 1h-3.8a1.2 1.2 0 00-1 .7l-2 7a.985.985 0 00.9 1.3h3.7l-1.5 7 7.3-9.4a1.014 1.014 0 00-.8-1.6h-3l1.1-3.7a.985.985 0 00-.9-1.3z"
      />
    </g>
  </svg>
);

export const Setpoints = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(.5 .5)">
      <path className="stroke" d="M10.165 12.166A9.341 9.341 0 012.683 4.69" />
      <path className="stroke" d="M4.5 2.5h6" />
      <circle
        className="stroke"
        cx="2"
        cy="2"
        r="2"
        transform="translate(.5 .5)"
      />
      <circle
        className="stroke"
        cx="2"
        cy="2"
        r="2"
        transform="translate(10.5 .5)"
      />
      <circle
        className="stroke"
        cx="2"
        cy="2"
        transform="translate(10.5 10.5)"
        r="2"
      />
    </g>
  </svg>
);

export const SystemResponse = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.809"
    height="14.172"
    viewBox="0 0 16.809 14.172"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path
        className="stroke"
        d="M1.401 12.683l5.197-6.88 3.456 6.572 5.347-6.459"
      />
      <path className="stroke" d="M2.401 1h.5" />
      <path className="stroke" d="M6.401 1h.5" />
      <path className="stroke" d="M10.401 1h.5" />
      <path className="stroke" d="M14.401 1h.5" />
    </g>
  </svg>
);

export const Clock = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8zm0 14a6 6 0 116-6 6.018 6.018 0 01-6 6z"
    />
    <path strokeWidth={1} className="fill" d="M9 4H7v5h5V7H9z" />
  </svg>
);

export const Add = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M13.125 6.125h-5.25V.875A.827.827 0 007 0a.827.827 0 00-.875.875v5.25H.875A.827.827 0 000 7a.827.827 0 00.875.875h5.25v5.25A.827.827 0 007 14a.827.827 0 00.875-.875v-5.25h5.25A.827.827 0 0014 7a.827.827 0 00-.875-.875z"
    />
  </svg>
);

export const Filter = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M14 1H2a.945.945 0 00-1 1v2a.909.909 0 00.4.8L6 9.5V15a.875.875 0 00.6.9.6.6 0 00.4.1.908.908 0 00.7-.3l2-2a.908.908 0 00.3-.7V9.5l4.6-4.7A.909.909 0 0015 4V2a.945.945 0 00-1-1z"
    />
  </svg>
);

export const Info = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8zm0 14a6 6 0 116-6 6.018 6.018 0 01-6 6z"
    />
    <path className="fill" d="M7 7h2v5H7z" />
    <circle className="fill" cx="1" cy="1" r="1" transform="translate(7 4)" />
  </svg>
);

export const ThumbsUp = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M6 23H1V12h5"
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      className="stroke"
      d="M6 12L9 1h0a3 3 0 013 3v6h7.5a3 3 0 012.965 3.456l-1.077 7A3 3 0 0118.426 23H6z"
      strokeLinecap="square"
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);

export const ManualOverride = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20.49"
    height="24"
    viewBox="0 0 20.49 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      fill="none"
      d="M4.28 1h-3v3M17.28 4V1h-3M10.81 9.36V5.1a1.87 1.87 0 00-1.5-1.87 1.8 1.8 0 00-2.1 1.77v11.7l-3.55-2.13a1.75 1.75 0 00-1.88.05 1.75 1.75 0 00-.26 2.7l5.69 5.7H18l1.42-9.2a2.7 2.7 0 00-2.1-3.05z"
    />
  </svg>
);

export const MechanicalIssue = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M22.71 4.89l-3.09 3.07-3.6-3.58 3.09-3.07A8.04 8.04 0 0016.85 1a5.62 5.62 0 00-5.14 5.73 4.22 4.22 0 00.3 1.64l-9.86 8.7a3.43 3.43 0 00-.21 4.91h0a3.3 3.3 0 004.94-.2l8.73-9.82a6.75 6.75 0 002.88.2 5.7 5.7 0 004.32-4 5.9 5.9 0 00-.1-3.26z"
      fill="none"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);

export const User = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M4.90504 8.69101L1.87404 10.578C1.60449 10.7493 1.38289 10.9862 1.23001 11.2666C1.07713 11.547 0.998 11.8617 1.00004 12.181V15.001H13V12.181C13.0014 11.8622 12.9219 11.5482 12.7691 11.2685C12.6163 10.9887 12.395 10.7522 12.126 10.581L9.09504 8.69101"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.00041 9.31301C6.11345 9.28068 5.27548 8.898 4.6702 8.24886C4.06492 7.59971 3.74171 6.73707 3.77141 5.85001V4.46401C3.74171 3.57695 4.06492 2.7143 4.6702 2.06516C5.27548 1.41601 6.11345 1.03333 7.00041 1.00101V1.00101C7.88738 1.03333 8.72534 1.41601 9.33063 2.06516C9.93591 2.7143 10.2591 3.57695 10.2294 4.46401V5.85001C10.2591 6.73707 9.93591 7.59971 9.33063 8.24886C8.72534 8.898 7.88738 9.28068 7.00041 9.31301V9.31301Z"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const TenantRequest = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22.83"
    height="23.34"
    viewBox="0 0 22.83 23.34"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      strokeMiterlimit="10"
      strokeWidth="2"
      fill="none"
      d="M8.72 15.86L4.1 18.63a1.62 1.62 0 00-.79 1.39v2.32h16.2v-2.32a1.62 1.62 0 00-.78-1.4l-4.62-2.76"
    />
    <path
      className="stroke"
      strokeMiterlimit="10"
      strokeWidth="2"
      fill="none"
      d="M11.41 16.6h0a4 4 0 01-4-4v-2a4 4 0 014-4h0a4 4 0 014 4v2a4 4 0 01-4 4z"
      strokeLinecap="square"
    />
    <path
      className="stroke"
      strokeMiterlimit="10"
      strokeWidth="2"
      fill="none"
      d="M.41 6.1l11-5 11 5"
    />
  </svg>
);

export const ProgrammingIssue = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      fill="none"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 11l-2 2 2 2M15 11l2 2-2 2M10 17l2-8"
    />
    <path
      className="stroke"
      fill="none"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 1h20v20H1zM1 5h20M6 1v4"
    />
  </svg>
);

export const Weather = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinecap="square"
      d="M9.1 9.1A5.04 5.04 0 0114 5a4.95 4.95 0 015 5 5.14 5.14 0 01-1 3"
    />
    <path
      className="stroke"
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinecap="square"
      d="M23 10h-1M20.4 3.6l-.7.7M14 1v1M7.6 3.6l.7.7M18 13a5.04 5.04 0 00-3.2 1.2A7.08 7.08 0 008 9a7 7 0 000 14h10a5 5 0 000-10z"
    />
  </svg>
);

export const WeatherLarge = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    {...props}
  >
    <path
      d="M15.4199 19.3173C16.8999 13.5664 22.1208 9.31641 28.3333 9.31641C35.6975 9.31641 41.6666 15.2856 41.6666 22.6498C41.6666 24.7356 41.1875 26.7089 40.3341 28.4664"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M28.333 0.982422V4.31576"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M43.6544 7.32812L41.2969 9.68563"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0127 7.32812L15.3702 9.68563"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M50.0003 22.6484H46.667"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M38.6368 28.3639C35.8151 28.3639 33.2659 29.4256 31.2784 31.1206C29.4851 24.3314 23.2934 19.3164 15.9092 19.3164C7.12252 19.3164 0 26.4048 0 35.1498C0 43.894 7.12252 50.9831 15.9092 50.9831H38.6368C44.9126 50.9831 50.0001 45.9198 50.0001 39.674C50.0001 33.4281 44.9126 28.3639 38.6368 28.3639Z"
      className="fill"
    />
  </svg>
);

export const Other = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      fill="none"
      strokeLinecap="square"
      strokeWidth="2"
      d="M1 12h4M4.2 4.2l2.3 2.3M12 1v4M19.8 4.2l-2.3 2.3M23 12h-4M19.8 19.8l-2.3-2.3M12 23v-4M4.2 19.8l2.3-2.3"
    />
  </svg>
);

export const CircleCheckLight = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="m8 16 5.333 5.333L24 10.667"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16 30.667c8.1 0 14.667-6.567 14.667-14.667S24.1 1.333 16 1.333 1.333 7.9 1.333 16 7.9 30.667 16 30.667Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const CircleCheckBold = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Z"
      className="fill"
    />
    <path
      d="M7 11.422 3.586 8.008 5 6.594l2 2 4-4 1.414 1.414L7 11.422Z"
      className="fill"
    />
  </svg>
);

export const CircledCheck = CircleCheckBold;

export const ActiveNotification = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
  >
    <g transform="translate(-1 -1)">
      <circle
        className="stroke"
        cx="10"
        cy="10"
        r="10"
        transform="translate(2 2)"
        fill="none"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <circle className="fill" cx="5" cy="5" r="5" transform="translate(7 7)" />
    </g>
  </svg>
);

export const Calendar = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 2h-2V0h-3v2H6V0H3v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-1 12H2V7h12z"
    />
  </svg>
);

export const Waste = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15.645"
    viewBox="0 0 16 15.645"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M12.784 4.962l-.538 8.531a1.24 1.24 0 01-1.237 1.152H4.636a1.24 1.24 0 01-1.237-1.152l-.538-8.531"
      className="stroke"
    />
    <path className="stroke" d="M1 4h14" />
    <path className="stroke" d="M4 11h8" />
    <path
      d="M5.341 3.481V1.62a.62.62 0 01.62-.62h3.721a.62.62 0 01.62.62v1.861"
      className="stroke"
    />
  </svg>
);

export const Energy = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10.53"
    height="16.004"
    viewBox="0 0 10.53 16.004"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="stroke"
      d="M1.414 8.002h7.78v3.112a3.89 3.89 0 01-3.89 3.888h0a3.89 3.89 0 01-3.89-3.888z"
    />
    <path className="stroke" d="M3.413 8.004v-3.5" />
    <path className="stroke" d="M7.413 8.004v-3.5" />
    <path className="stroke" d="M1.414 2.634a5.446 5.446 0 017.7-.078" />
  </svg>
);

export const SubmitEnergyStar = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.002"
    height="15.612"
    viewBox="0 0 16.002 15.612"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g>
      <path className="fill" d="M16 11.612h-2v-2h-2v2h-2v2h2v2h2v-2h2z" />
      <path
        className="fill"
        d="M8 10.865l-.93.489L5 12.441l.395-2.3.178-1.036-.753-.734-1.671-1.632 2.312-.336L6.5 6.252l.467-.94L8 3.212l1.035 2.1.465.94 1.041.151 2.312.336-.9.873h2.865l.878-.855a1 1 0 00-.555-1.706l-4.316-.627L8.9.512a1.042 1.042 0 00-1.8 0L5.174 4.423.857 5.05A1 1 0 00.3 6.757l3.124 3.044-.737 4.3a1 1 0 001.453 1.054L8 13.125z"
      />
    </g>
  </svg>
);

export const EnergyStarLarge = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69.143"
    height="58"
    viewBox="0 0 69.143 58"
    className={classnames("icon", className)}
    {...props}
  >
    <g transform="translate(-2, 0)">
      <path
        className="stroke"
        d="M10.05,31.437l20.345-2.956,9.1-18.431,9.1,18.431,20.345,2.956L54.214,45.788,57.688,66.05l-18.2-9.563L21.3,66.05l3.474-20.262"
        transform="translate(-2.546 -10.05)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className="stroke"
        d="M62.383,0c3.09,1.345,5.253,3.281,5.253,5.367,0,5.518-15.141,9.99-33.818,9.99S0,10.884,0,5.367c.146-1.177.8-2.3,2.362-3.7"
        transform="translate(66.253 13.957) rotate(150)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const ConsumptionBars = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="10"
    strokeWidth="2px"
    {...props}
  >
    <path className="stroke" d="M19 10v4H1v-4zM8 1v4H1V1zM13 19v4H1v-4z" />
  </svg>
);

export const GHG = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="21.02"
    height="19.957"
    viewBox="0 0 21.02 19.957"
    fill="none"
    strokeLinecap="square"
    strokeWidth="2px"
    {...props}
  >
    <g transform="translate(-1.994 3)">
      <path
        className="stroke"
        d="M16.562,16.968a3.458,3.458,0,0,0,0-6.916h0a6.5,6.5,0,0,0-12.968.086,3.471,3.471,0,0,0,.865,6.83Z"
        transform="translate(1.994 -1.011)"
      />
      <line className="stroke" transform="translate(13 -3)" />
      <line className="stroke" transform="translate(7)" />
      <line className="stroke" transform="translate(18)" />
    </g>
  </svg>
);

export const Benchmark = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22.414"
    height="24.414"
    viewBox="0 0 22.414 24.414"
    fill="none"
    strokeLinecap="round"
    strokeWidth="2px"
    {...props}
  >
    <line className="stroke" x1="3" y1="3" transform="translate(18 20)" />
    <path
      className="stroke"
      d="M1,12H6.243L8.864,7l3.5,10,2.621-5h5.243"
      transform="translate(0 -1.845)"
    />
    <circle
      className="stroke"
      cx="10"
      cy="10"
      r="10"
      transform="translate(1 1)"
    />
  </svg>
);

export const GraphControl = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="10"
    strokeWidth="2px"
    {...props}
  >
    <g transform="translate(-5 -5)">
      <path className="stroke" d="M16 15v3M16 6v2" />
      <circle
        className="stroke"
        cx="2"
        cy="2"
        r="2"
        transform="translate(14 8)"
      />
      <path className="stroke" d="M8 6v3M8 16v2" />
      <circle
        className="stroke"
        cx="2"
        cy="2"
        r="2"
        transform="translate(6 12)"
      />
    </g>
  </svg>
);

export const BuildingData = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="22"
    strokeWidth="2"
    fill="none"
    {...props}
  >
    <g transform="translate(-977 -353)">
      <path className="stroke" d="M981.54 370.48l9.88-12.91" />
      <circle
        className="fill"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(977 366)"
      />
      <circle
        className="fill"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(987 353)"
      />
    </g>
  </svg>
);

export const PreviousYears = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="22"
    fill="none"
    strokeWidth="2"
    {...props}
  >
    <path className="stroke" d="M6.54 14.86 l 5.88 -7.683" />
    <g transform="translate(0 13)">
      <circle className="stroke" cx="4.5" cy="4.5" r="3.5" />
    </g>
    <g transform="translate(10)">
      <circle className="stroke" cx="4.5" cy="4.5" r="3.5" />
    </g>
  </svg>
);

export const ProductTier = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24.65"
    height="22.1"
    strokeLinecap="round"
    {...props}
  >
    <path
      className="stroke"
      d="M4.32 14.1h8v7h-8zM12.32 14.1h8v7h-8zM8.32 7.1h8v7h-8zM1.32 6.1l11-5 11 5M12.32 7.1v2M16.32 14.1v2M8.32 14.1v2"
    />
  </svg>
);

export const UtilityConnect = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    strokeLinecap="round"
    strokeWidth="2px"
    {...props}
  >
    <path
      d="M13 12a2 2 0 01-4 0V4a4 4 0 10-8 0v6h2V4a2 2 0 114 0v8a4 4 0 008 0V6h-2z"
      className="fill"
    />
    <circle className="fill" cx="2" cy="2" r="2" transform="translate(0 12)" />
    <circle className="fill" cx="2" cy="2" r="2" transform="translate(12)" />
  </svg>
);

export const LargeUtilityConnect = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g>
      <path
        className="stroke"
        d="M5 19V6.5A5.5 5.5 0 0110.5 1 5.5 5.5 0 0116 6.5v19a5.5 5.5 0 005.5 5.5 5.5 5.5 0 005.5-5.5V13"
      />
      <circle
        className="stroke"
        cx="4"
        cy="4"
        r="4"
        transform="translate(23 1)"
      />
      <circle
        className="stroke"
        cx="4"
        cy="4"
        r="4"
        transform="translate(1 23)"
      />
    </g>
  </svg>
);

export const History = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="fill" d="M8 6v4h4V8h-2V6z" />
    <path
      className="fill"
      d="M10 0a8.009 8.009 0 00-8 8H0l3 4.817L6 8H4a6.012 6.012 0 111.733 4.211l-1.076 1.726A7.995 7.995 0 1010 0z"
    />
  </svg>
);

export const PortfolioSavings = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24.414"
    viewBox="0 0 24 24.414"
    preserveAspectRatio="xMidYMid meet"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path className="stroke" d="M16 11h-4V7" />
    <circle cx="4" cy="4" r="4" transform="translate(8 7)" className="stroke" />
    <path className="stroke" d="M12 19v3" />
    <path className="stroke" d="M10 19l-4 4" />
    <path className="stroke" d="M14 19l4 4" />
    <path className="stroke" d="M21 19V3H3v16" />
    <path className="stroke" d="M1 19h22" />
    <path className="stroke" d="M12 3V1" />
  </svg>
);

export const PortfolioProjects = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    preserveAspectRatio="xMidYMid meet"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g>
      <path className="stroke" d="M1 9h18v14H1z" />
      <path className="stroke" d="M3 5h14" />
      <path className="stroke" d="M6 1h8" />
    </g>
  </svg>
);

export const PortfolioConsumption = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <circle
      className="stroke"
      cx="11"
      cy="11"
      r="11"
      transform="translate(1 1)"
    />
    <path className="stroke" d="M10.59 10.59L7 7" />
    <circle
      className="stroke"
      cx="2"
      cy="2"
      r="2"
      transform="translate(10 10)"
    />
    <path className="stroke" d="M12 5v1" />
    <path className="stroke" d="M16.95 7.05l-.707.707" />
    <path className="stroke" d="M19 12h-1" />
    <path className="stroke" d="M6 12H5" />
  </svg>
);

export const PortfolioComparisons = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g>
      <path className="stroke" d="M19 10v4H1v-4z" />
      <path className="stroke" d="M8 1v4H1V1z" />
      <path className="stroke" d="M13 19v4H1v-4z" />
    </g>
  </svg>
);

export const Connected = ({ className, ...props }: ComponentProps<"svg">) => {
  const styles = {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
  };
  return (
    <svg
      className={classnames("icon", className)}
      width="22.828"
      height="10.828"
      viewBox="0 0 22.828 10.828"
      {...props}
    >
      <defs />
      <g transform="translate(-0.586 -7.586)">
        <line
          className="stroke"
          style={styles}
          x2="7"
          transform="translate(2 13)"
        />
        <path
          className="stroke"
          style={{ ...styles, strokeLinecap: "square" }}
          d="M6,17,2,13,6,9"
        />
        <line
          className="stroke"
          style={styles}
          x1="7"
          transform="translate(15 13)"
        />
        <path
          className="stroke"
          style={{ ...styles, strokeLinecap: "square" }}
          d="M18,17l4-4L18,9"
        />
        <circle
          className="stroke"
          style={{ ...styles, strokeLinecap: "square" }}
          cx="3"
          cy="3"
          r="3"
          transform="translate(9 10)"
        />
      </g>
    </svg>
  );
};

export const AutoSave = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round">
      <path className="stroke" d="M1 1v14h14V5.1L11.021 1z" />
      <path className="stroke" d="M5 9h6v6H5z" />
      <path className="stroke" d="M5 1h6v4H5z" />
    </g>
  </svg>
);

export const Unlock = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      className="fill"
      d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
    />
  </svg>
);

export const Leed = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <g>
      <path
        className="stroke"
        d="M.006 4.598h7.911a3.28 3.28 0 013.28 3.281 3.28 3.28 0 01-3.28 3.281 3.28 3.28 0 01-3.28-3.281v-.943"
      />
      <path
        className="stroke"
        d="M0 1h8.033a7.014 7.014 0 017.013 7.015 7.014 7.014 0 01-7.013 7.015 7.014 7.014 0 01-7.012-7.015V6.976"
      />
    </g>
  </svg>
);

export const NotConnected = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22.828"
    height="10.828"
    viewBox="0 0 22.828 10.828"
    {...props}
  >
    <g>
      <path className="stroke" d="M1.414 5.414h7" />
      <path className="stroke" d="M11.414 1.414v8" />
      <path
        className="stroke"
        d="M5.414 9.414l-4-4 4-4"
        strokeLinecap="square"
      />
      <path className="stroke" d="M21.414 5.414h-7" />
      <path
        className="stroke"
        d="M17.414 9.414l4-4-4-4"
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export const ConnectedMeter = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="11"
    viewBox="0 0 12 11"
    {...props}
  >
    <path className="fill" d="M10 6v3H2V6H0v4a1 1 0 001 1h10a1 1 0 001-1V6z" />
    <path className="fill" d="M5 6h2V4h2V2H7V0H5v2H3v2h2z" />
  </svg>
);

export const Bell = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9.5"
    viewBox="0 0 9 9.5"
    {...props}
  >
    <g>
      <path
        className="fill"
        d="M8.625 6A1.236 1.236 0 017.5 4.875V3a3 3 0 10-6 0v1.875A1.236 1.236 0 01.375 6a.375.375 0 000 .75h8.25a.375.375 0 000-.75z"
      />
      <path
        className="fill"
        d="M4.5 9.5A1.5 1.5 0 006 8H3a1.5 1.5 0 001.5 1.5z"
      />
    </g>
  </svg>
);

export const Arrow = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="6.828"
    height="8"
    viewBox="0 0 6.828 8"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round">
      <path className="stroke" d="M3.414 1v6" />
      <path className="stroke" d="M5.414 5l-2 2-2-2" />
    </g>
  </svg>
);

export const ArrowDownThick = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="10"
    viewBox="0 0 8 10"
    {...props}
  >
    <path
      d="M4.5 0h-1a.5.5 0 0 0-.5.5V5H.5a.5.5 0 0 0-.376.829l3.5 4a.5.5 0 0 0 .752 0l3.5-4A.5.5 0 0 0 7.5 5H5V.5a.5.5 0 0 0-.5-.5Z"
      className="fill"
    />
  </svg>
);

export const CustomerSatisfaction = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g transform="translate(1 1)" strokeLinecap="round">
      <circle className="stroke" cx="11" cy="11" r="11" />
      <path className="stroke" d="M17 9a2 2 0 00-4 0" />
      <path className="stroke" d="M9 9a2 2 0 10-4 0" />
      <path className="stroke" d="M9 16h2.6a5.78 5.78 0 004.087-1.693L16 14" />
    </g>
  </svg>
);

export const Share = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16.545"
    height="18"
    viewBox="0 0 16.545 18"
  >
    <g transform="translate(1 1)">
      <line
        className="stroke"
        y1="3.636"
        x2="6.4"
        transform="translate(4.073 3.273)"
        strokeWidth="2"
      />
      <line
        className="stroke"
        x2="6.4"
        y2="3.636"
        transform="translate(4.073 9.091)"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="2.182"
        cy="2.182"
        r="2.182"
        transform="translate(0 5.818)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="2.182"
        cy="2.182"
        r="2.182"
        transform="translate(10.182)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="2.182"
        cy="2.182"
        r="2.182"
        transform="translate(10.182 11.636)"
        strokeLinecap="square"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const Overview = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    {...props}
  >
    <g transform="translate(-2)">
      <rect
        className="stroke"
        width="18"
        height="22"
        transform="translate(3 1)"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="5"
        cy="5"
        r="5"
        transform="translate(7 7)"
        strokeWidth="2"
      />
      <path className="fill" d="M12,12h5a5,5,0,0,0-5-5Z" />
    </g>
  </svg>
);

export const BuildingDesign = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path className="stroke" d="M15,21H7a4,4,0,0,1-4-4V9" strokeWidth="2" />
    <path className="stroke" d="M9,3h8a4,4,0,0,1,4,4v8" strokeWidth="2" />
    <rect
      className="stroke"
      width="4"
      height="4"
      transform="translate(1 1)"
      strokeWidth="2"
    />
    <rect
      className="stroke"
      width="4"
      height="4"
      transform="translate(19 19)"
      strokeWidth="2"
    />
  </svg>
);

export const Utilities = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      className="stroke"
      d="M19.55,20A11,11,0,1,0,12,23V20"
      strokeWidth="2"
    />
    <path
      className="stroke"
      d="M12,17h0a5,5,0,0,1-5-5V9H17v3A5,5,0,0,1,12,17Z"
      strokeWidth="2"
    />
    <line
      className="stroke"
      y1="3"
      transform="translate(9 6)"
      strokeWidth="2"
    />
    <line
      className="stroke"
      y1="3"
      transform="translate(15 6)"
      strokeWidth="2"
    />
  </svg>
);

export const Certifications = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="17.172"
    height="24.517"
    viewBox="0 0 17.172 24.517"
    {...props}
  >
    <g transform="translate(-5)">
      <path
        className="stroke"
        d="M19.621,18.14v9l-5.31-2.276L9,27.137v-9"
        transform="translate(-0.724 -4.137)"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="7.586"
        cy="7.586"
        r="7.586"
        transform="translate(6 1)"
        strokeLinecap="square"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const Financial = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
    {...props}
  >
    <g transform="translate(0 -3)">
      <rect
        className="stroke"
        width="22"
        height="16"
        transform="translate(1 4)"
        strokeWidth="2"
      />
      <circle
        className="stroke"
        cx="3"
        cy="3"
        r="3"
        transform="translate(9 9)"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const Operations = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    {...props}
  >
    <g transform="translate(-1 -1)">
      <rect
        className="stroke"
        width="20"
        height="20"
        transform="translate(2 2)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y2="6"
        transform="translate(16 12)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y2="2"
        transform="translate(16 6)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        x1="4"
        transform="translate(14 8)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y2="6"
        transform="translate(8 6)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y2="2"
        transform="translate(8 16)"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        x1="4"
        transform="translate(6 16)"
        strokeLinecap="square"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const MoveLayer = ({
  className,
  open,
  ...props
}: ComponentProps<"svg"> & { open?: string }) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      d="M1,12a1,1,0,0,0,1-1V1A1,1,0,1,0,0,1V11a1,1,0,0,0,1,1Z"
      fill="#b9c3e1"
      className="fill"
      strokeLinecap="round"
      style={
        open
          ? {
              opacity: 1,
            }
          : {
              opacity: 0,
            }
      }
    />
    <path
      d="M11.5,5H9V2.5a.5.5,0,0,0-.829-.376l-4,3.5a.5.5,0,0,0,0,.752l4,3.5A.5.5,0,0,0,9,9.5V7h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,11.5,5Z"
      fill="#b9c3e1"
      className="fill"
      strokeLinecap="round"
      style={
        !open
          ? {
              transform: "rotateY(180deg)",
              transformOrigin: "center",
            }
          : {}
      }
    />
    <path
      d="M1,12a1,1,0,0,1-1-1V1A1,1,0,1,1,2,1V11a1,1,0,0,1-1,1Z"
      transform="translate(10)"
      fill="#b9c3e1"
      className="fill"
      strokeLinecap="round"
      style={
        !open
          ? {
              opacity: 1,
            }
          : {
              opacity: 0,
            }
      }
    />
  </svg>
);

export const MoveLayerLeft = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      d="M1,12a1,1,0,0,0,1-1V1A1,1,0,1,0,0,1V11a1,1,0,0,0,1,1Z"
      fill="#b9c3e1"
      className="fill"
    />
    <path
      d="M11.5,5H9V2.5a.5.5,0,0,0-.829-.376l-4,3.5a.5.5,0,0,0,0,.752l4,3.5A.5.5,0,0,0,9,9.5V7h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,11.5,5Z"
      fill="#b9c3e1"
      className="fill"
    />
  </svg>
);

export const MoveLayerRight = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      d="M1,12a1,1,0,0,1-1-1V1A1,1,0,1,1,2,1V11a1,1,0,0,1-1,1Z"
      transform="translate(10)"
      fill="#b9c3e1"
      className="fill"
    />
    <path
      d="M4.5,5H7V2.5a.5.5,0,0,1,.829-.376l4,3.5a.5.5,0,0,1,0,.752l-4,3.5A.5.5,0,0,1,7,9.5V7H4.5A.5.5,0,0,1,4,6.5v-1A.5.5,0,0,1,4.5,5Z"
      transform="translate(-4.001)"
      fill="#b9c3e1"
      className="fill"
    />
  </svg>
);

export const BarChart = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="22"
    height="20"
    viewBox="0 0 22 20"
    {...props}
  >
    <g id="Icon" transform="translate(-1 -2)">
      <line
        className="stroke"
        y1="13"
        transform="translate(7 8)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y1="8"
        transform="translate(12 13)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y1="13"
        transform="translate(17 8)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y1="8"
        transform="translate(22 13)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <line
        className="stroke"
        y1="18"
        transform="translate(2 3)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const Source = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="18"
    height="16"
    viewBox="0 0 18 16"
    {...props}
  >
    <g transform="translate(0 -2)">
      <rect
        width="16"
        height="14"
        transform="translate(1 3)"
        fill="none"
        className="stroke"
        stroke="#b9c3e1"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        x2="8"
        transform="translate(5 8)"
        fill="none"
        stroke="#b9c3e1"
        strokeLinecap="square"
        strokeWidth="2"
      />
      <line
        className="stroke"
        x2="4"
        transform="translate(5 11.999)"
        fill="none"
        stroke="#b9c3e1"
        strokeLinecap="square"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const NewUtilityAccount = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="23"
    height="25"
    viewBox="0 0 23 25"
    {...props}
  >
    <path
      d="M6 7.70996H7"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11 7.70996H16"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6 12.71H7"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11 12.71H16"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6 17.71H11"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12 23.71H1V1.70996H21V13.71"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M19 17.71V23.71"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16 20.71H22"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const TriangleExclamation = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    {...props}
  >
    <path
      d="M1.657 25.27 13.536 2.816a2.79 2.79 0 0 1 4.933 0L30.348 25.27a2.773 2.773 0 0 1-2.47 4.062H4.122a2.771 2.771 0 0 1-2.466-4.062v0ZM16 10.667v8"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M16 25.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" className="fill" />
  </svg>
);

export const TriangleExclamationBold = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M9 6H7v4h2V6ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      className="fill"
    />
    <path
      d="M15 16H1a1.001 1.001 0 0 1-.895-1.448l7-14c.34-.678 1.449-.678 1.789 0l7 14A1 1 0 0 1 15 16ZM2.618 14h10.764L8 3.236 2.618 14Z"
      className="fill"
    />
  </svg>
);

export const StreamFluid = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21 5H23"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1 5H17"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M3 12H1"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M23 12H7"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21 19H23"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1 19H17"
      className="stroke"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BackpackUpload = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H11C11.2652 2 11.5196 1.89464 11.7071 1.70711C11.8946 1.51957 12 1.26522 12 1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0V0Z"
      className="fill"
    />
    <path
      d="M5.50047 12H6.50047C6.63308 12 6.76025 11.9474 6.85402 11.8536C6.94779 11.7598 7.00047 11.6326 7.00047 11.5V9.00004H9.50047C9.59645 8.99994 9.69038 8.97222 9.77104 8.92018C9.85169 8.86814 9.91566 8.79398 9.95531 8.70657C9.99496 8.61915 10.0086 8.52217 9.99463 8.42721C9.98065 8.33225 9.93963 8.24332 9.87647 8.17104L6.37647 4.17104C6.32822 4.1197 6.26996 4.07879 6.2053 4.05082C6.14063 4.02285 6.07092 4.00842 6.00047 4.00842C5.93001 4.00842 5.86031 4.02285 5.79564 4.05082C5.73097 4.07879 5.67272 4.1197 5.62447 4.17104L2.12447 8.17104C2.06131 8.24332 2.02029 8.33225 2.00631 8.42721C1.99233 8.52217 2.00598 8.61915 2.04562 8.70657C2.08527 8.79398 2.14924 8.86814 2.2299 8.92018C2.31055 8.97222 2.40448 8.99994 2.50047 9.00004H5.00047V11.5C5.00047 11.6326 5.05315 11.7598 5.14691 11.8536C5.24068 11.9474 5.36786 12 5.50047 12Z"
      className="fill"
    />
  </svg>
);

export const BackpackUploadAlt = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 23V7"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M6 13L12 7L18 13"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2 2H22"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BackpackHome = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 2L2 10V23H9V16H15V23H22V10L12 2Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BackpackFolder = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    {...props}
  >
    <path
      d="M21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V1H9L12 5H23V19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BackpackFolderPlus = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    {...props}
  >
    <path
      d="M22.6667 2.75H12.5333L10.2667 0.4125C10 0.1375 9.73333 0 9.33333 0H1.33333C0.533333 0 0 0.55 0 1.375V20.625C0 21.45 0.533333 22 1.33333 22H22.6667C23.4667 22 24 21.45 24 20.625V4.125C24 3.3 23.4667 2.75 22.6667 2.75ZM21.3333 19.25H2.66667V2.75H8.8L11.0667 5.0875C11.3333 5.3625 11.6 5.5 12 5.5H21.3333V19.25Z"
      className="fill"
    />
    <path
      d="M10.6667 8.25V11H8V13.75H10.6667V16.5H13.3333V13.75H16V11H13.3333V8.25H10.6667Z"
      className="fill"
    />
  </svg>
);

export const Star = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M11.8596 15.5419L7.99957 13.5129L4.13956 15.5419C3.41256 15.9289 2.54757 15.3069 2.68857 14.4879L3.42557 10.1889L0.301565 7.14495C-0.292435 6.56495 0.0385652 5.55795 0.856565 5.43895L5.17256 4.81194L7.10357 0.899945C7.43957 0.216945 8.56057 0.216945 8.89657 0.899945L10.8276 4.81095L15.1436 5.43795C15.9616 5.55695 16.2916 6.56395 15.6986 7.14395L12.5746 10.1889L13.3116 14.4879C13.4526 15.3109 12.5856 15.9239 11.8596 15.5419ZM8.46556 11.4979L10.9976 12.8289L10.5146 10.0089C10.4586 9.68495 10.5666 9.35395 10.8016 9.12395L12.8506 7.12595L10.0196 6.71495C9.69257 6.66795 9.41157 6.46295 9.26657 6.16795L7.99957 3.60195L6.73256 6.16795C6.58656 6.46295 6.30557 6.66795 5.97957 6.71495L3.14857 7.12595L5.19757 9.12395C5.43257 9.35295 5.54057 9.68495 5.48457 10.0089L5.00156 12.8289L7.53357 11.4979C7.82557 11.3439 8.17356 11.3439 8.46556 11.4979Z"
      className="fill"
    />
  </svg>
);

export const Leasing = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M5.625 6.25H14.375"
        stroke="#4C516A"
        strokeWidth="2"
        className="stroke"
      />
      <path
        d="M5.625 10H14.375"
        stroke="#4C516A"
        strokeWidth="2"
        className="stroke"
      />
      <path
        d="M5.625 13.75H9.375"
        stroke="#4C516A"
        strokeWidth="2"
        className="stroke"
      />
      <path
        d="M10.625 19.375H1.875V0.625H18.125V10.625"
        stroke="#4C516A"
        strokeWidth="2"
        className="stroke"
      />
      <path
        d="M16.25 12.5L13.125 15V19.375H16.25H19.375V15L16.25 12.5Z"
        stroke="#4C516A"
        strokeWidth="2"
        strokeLinecap="square"
        className="stroke"
      />
      <path
        d="M16.25 17.5V19.375"
        stroke="#4C516A"
        strokeWidth="2"
        className="stroke"
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export const Quoted = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.707 14.293L12.566 12.152C12.8469 11.6464 12.9961 11.0783 13 10.5C13 9.80777 12.7947 9.13108 12.4101 8.55551C12.0256 7.97993 11.4789 7.53133 10.8394 7.26642C10.1999 7.00152 9.49612 6.9322 8.81718 7.06725C8.13825 7.2023 7.51461 7.53564 7.02513 8.02513C6.53564 8.51461 6.2023 9.13825 6.06725 9.81718C5.9322 10.4961 6.00152 11.1999 6.26642 11.8394C6.53133 12.4789 6.97993 13.0256 7.55551 13.4101C8.13108 13.7947 8.80777 14 9.5 14C10.0783 13.9961 10.6464 13.8469 11.152 13.566L13.293 15.707C13.4816 15.8892 13.7342 15.99 13.9964 15.9877C14.2586 15.9854 14.5094 15.8802 14.6948 15.6948C14.8802 15.5094 14.9854 15.2586 14.9877 14.9964C14.99 14.7342 14.8892 14.4816 14.707 14.293ZM8 10.5C8 10.2033 8.08797 9.91332 8.2528 9.66665C8.41762 9.41997 8.65189 9.22771 8.92598 9.11418C9.20007 9.00065 9.50167 8.97095 9.79264 9.02882C10.0836 9.0867 10.3509 9.22956 10.5607 9.43934C10.7704 9.64912 10.9133 9.91639 10.9712 10.2074C11.0291 10.4983 10.9994 10.7999 10.8858 11.074C10.7723 11.3481 10.58 11.5824 10.3334 11.7472C10.0867 11.912 9.79667 12 9.5 12C9.10218 12 8.72065 11.842 8.43934 11.5607C8.15804 11.2794 8 10.8978 8 10.5Z"
      className="fill"
    />
    <path
      d="M10 0H2C1.73478 0 1.48043 0.105357 1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1V15C1 15.2652 1.10536 15.5196 1.29289 15.7071C1.48043 15.8946 1.73478 16 2 16H7C7.26522 16 7.51957 15.8946 7.70711 15.7071C7.89464 15.5196 8 15.2652 8 15C8 14.7348 7.89464 14.4804 7.70711 14.2929C7.51957 14.1054 7.26522 14 7 14H3V2H9V6H13V8C13 8.26522 13.1054 8.51957 13.2929 8.70711C13.4804 8.89464 13.7348 9 14 9C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8V5L10 0Z"
      className="fill"
    />
  </svg>
);

export const BidQualification = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
      className="fill"
    />
    <path d="M9.75 2.91663V15.0833H8.25V2.91663H9.75Z" className="fill" />
    <path
      d="M8.6106 4.5338C9.84661 4.45327 11.2643 4.74571 12.0127 5.13449L12.6782 5.48023L11.9867 6.81134L11.3212 6.4656C10.8576 6.22477 9.72219 5.96455 8.70813 6.03062C8.20598 6.06334 7.82824 6.17131 7.5978 6.32155C7.41012 6.44391 7.3108 6.59234 7.3108 6.86218C7.3108 7.21666 7.45 7.43387 7.7454 7.63846C8.09076 7.87765 8.58453 8.04858 9.21026 8.24555C9.25405 8.25934 9.29869 8.2733 9.34404 8.28748C9.88741 8.45744 10.5331 8.6594 11.0417 8.96894C11.6411 9.33379 12.1593 9.91601 12.1593 10.8307C12.1593 11.595 11.8868 12.225 11.3823 12.6754C10.9025 13.1038 10.2792 13.3109 9.66605 13.3978C8.44626 13.5706 6.98713 13.3075 5.83386 12.9141L5.12402 12.672L5.6083 11.2523L6.31813 11.4945C7.34673 11.8453 8.55427 12.0403 9.45568 11.9126C9.90311 11.8492 10.2041 11.7165 10.3833 11.5565C10.538 11.4184 10.6593 11.2112 10.6593 10.8307C10.6593 10.6006 10.5715 10.4387 10.2618 10.2503C9.91669 10.0402 9.4395 9.89013 8.82899 9.69808C8.80613 9.6909 8.78309 9.68365 8.75987 9.67634C8.17347 9.49174 7.4551 9.26202 6.89136 8.87159C6.27766 8.44655 5.8108 7.80516 5.8108 6.86218C5.8108 6.04828 6.19824 5.44338 6.77858 5.06501C7.31617 4.71453 7.98772 4.57438 8.6106 4.5338Z"
      className="fill"
    />
  </svg>
);

export const DashedCircledCheck = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1152_27550)">
      <path
        d="M7.00008 11.0006C6.73489 11.0005 6.48057 10.8951 6.29308 10.7076L4.29308 8.70757C4.19757 8.61532 4.12139 8.50498 4.06898 8.38297C4.01657 8.26097 3.98898 8.12975 3.98783 7.99697C3.98668 7.86419 4.01198 7.73251 4.06226 7.60962C4.11254 7.48672 4.18679 7.37507 4.28069 7.28117C4.37458 7.18728 4.48623 7.11303 4.60913 7.06275C4.73202 7.01247 4.8637 6.98717 4.99648 6.98832C5.12926 6.98947 5.26048 7.01706 5.38249 7.06947C5.50449 7.12188 5.61483 7.19806 5.70708 7.29357L7.00008 8.58657L10.2931 5.29357C10.3853 5.19806 10.4957 5.12188 10.6177 5.06947C10.7397 5.01706 10.8709 4.98947 11.0037 4.98832C11.1365 4.98717 11.2681 5.01247 11.391 5.06275C11.5139 5.11303 11.6256 5.18728 11.7195 5.28117C11.8134 5.37507 11.8876 5.48672 11.9379 5.60962C11.9882 5.73251 12.0135 5.86419 12.0123 5.99697C12.0112 6.12975 11.9836 6.26097 11.9312 6.38297C11.8788 6.50498 11.8026 6.61532 11.7071 6.70757L7.70708 10.7076C7.51959 10.8951 7.26528 11.0005 7.00008 11.0006Z"
        className="fill"
      />
      <path
        d="M2.40718 4.78827C2.56243 4.78827 2.71554 4.75212 2.85439 4.68269C2.99325 4.61327 3.11403 4.51246 3.20718 4.38827C3.51982 3.97451 3.88449 3.60278 4.29218 3.28227C4.50064 3.11823 4.6354 2.8781 4.66681 2.61471C4.69822 2.35131 4.62372 2.08623 4.45968 1.87777C4.29564 1.66931 4.05552 1.53455 3.79212 1.50314C3.52873 1.47172 3.26364 1.54623 3.05518 1.71027C2.51203 2.13839 2.02606 2.63444 1.60918 3.18627C1.49775 3.33484 1.4299 3.5115 1.41322 3.69646C1.39654 3.88142 1.4317 4.06737 1.51475 4.23348C1.59781 4.39959 1.72547 4.53928 1.88345 4.63692C2.04143 4.73455 2.22347 4.78627 2.40918 4.78627L2.40718 4.78827Z"
        className="fill"
      />
      <path
        d="M2.052 8.79043C2.01754 8.52817 2.00017 8.26394 2 7.99943C1.99977 7.745 2.0158 7.49081 2.048 7.23843C2.08169 6.97533 2.00947 6.70963 1.84726 6.49978C1.68504 6.28993 1.4461 6.15311 1.183 6.11943C0.919908 6.08575 0.654209 6.15796 0.444355 6.32018C0.234502 6.48239 0.0976853 6.72133 0.0640028 6.98443C-0.0229764 7.67046 -0.0212959 8.36483 0.0690028 9.05043C0.10052 9.29081 0.218291 9.51156 0.400402 9.67159C0.582514 9.83163 0.816564 9.92006 1.059 9.92043C1.10282 9.92042 1.14659 9.91741 1.19 9.91143C1.45296 9.87706 1.69149 9.73966 1.85314 9.52943C2.0148 9.31921 2.08633 9.05339 2.052 8.79043Z"
        className="fill"
      />
      <path
        d="M3.22376 11.6339C3.14554 11.5259 3.04652 11.4347 2.93255 11.3656C2.81857 11.2965 2.69192 11.2509 2.56006 11.2314C2.42819 11.212 2.29376 11.2191 2.16468 11.2523C2.0356 11.2855 1.91446 11.3443 1.8084 11.425C1.70233 11.5057 1.61348 11.6068 1.54706 11.7224C1.48064 11.838 1.43799 11.9657 1.42163 12.0979C1.40526 12.2302 1.41551 12.3644 1.45177 12.4927C1.48803 12.621 1.54956 12.7407 1.63276 12.8449C2.05138 13.3951 2.53943 13.8889 3.08476 14.3139C3.29402 14.477 3.5595 14.5503 3.8228 14.5176C4.0861 14.485 4.32565 14.3491 4.48876 14.1399C4.65187 13.9306 4.72517 13.6651 4.69254 13.4018C4.65991 13.1385 4.52402 12.899 4.31476 12.7359C3.90489 12.4173 3.53815 12.0469 3.22376 11.6339Z"
        className="fill"
      />
      <path
        d="M8.00016 0C7.61976 0.000261748 7.23984 0.026993 6.86316 0.08C6.61305 0.115624 6.38569 0.244594 6.22678 0.44099C6.06787 0.637386 5.98918 0.886652 6.00653 1.13869C6.02388 1.39073 6.13599 1.62686 6.32031 1.79962C6.50464 1.97239 6.74753 2.06899 7.00016 2.07C7.0473 2.06999 7.0944 2.06699 7.14116 2.061C7.42574 2.02086 7.71276 2.00048 8.00016 2C9.59146 2 11.1176 2.63214 12.2428 3.75736C13.368 4.88258 14.0002 6.4087 14.0002 8C14.0002 9.5913 13.368 11.1174 12.2428 12.2426C11.1176 13.3679 9.59146 14 8.00016 14C7.71276 13.9995 7.42574 13.9791 7.14116 13.939C7.01108 13.9207 6.87869 13.9283 6.75153 13.9612C6.62437 13.9941 6.50494 14.0518 6.40006 14.1308C6.18824 14.2905 6.04852 14.5278 6.01166 14.7905C5.9934 14.9206 6.00095 15.053 6.03386 15.1801C6.06678 15.3073 6.12441 15.4267 6.20348 15.5316C6.36317 15.7434 6.60046 15.8831 6.86316 15.92C7.23984 15.973 7.61976 15.9997 8.00016 16C10.1219 16 12.1567 15.1571 13.657 13.6569C15.1573 12.1566 16.0002 10.1217 16.0002 8C16.0002 5.87827 15.1573 3.84344 13.657 2.34315C12.1567 0.842855 10.1219 0 8.00016 0V0Z"
        className="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_1152_27550">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EllipsisCircled = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14Z"
      className="fill"
    />
    <circle cx="5" cy="8" r="1" className="fill" />
    <circle cx="8" cy="8" r="1" className="fill" />
    <circle cx="11" cy="8" r="1" className="fill" />
  </svg>
);

export const CalendarInProgress = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M15 2H13V0H10V2H6V0H3V2H1C0.448 2 0 2.448 0 3V15C0 15.552 0.448 16 1 16H3V14H2V7H14V14H13V16H15C15.552 16 16 15.552 16 15V3C16 2.448 15.552 2 15 2Z"
      className="fill"
    />
    <circle cx="5" cy="15" r="1" className="fill" />
    <circle cx="8" cy="15" r="1" className="fill" />
    <circle cx="11" cy="15" r="1" className="fill" />
  </svg>
);

export const CalendarComplete = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.99997 16C6.74397 16 6.48797 15.902 6.29297 15.707L4.29297 13.707L5.70697 12.293L6.99997 13.586L10.293 10.293L11.707 11.707L7.70697 15.707C7.51197 15.902 7.25597 16 6.99997 16Z"
      className="fill"
    />
    <path
      d="M15 2H13V0H10V2H6V0H3V2H1C0.448 2 0 2.448 0 3V15C0 15.552 0.448 16 1 16H3V14H2V7H14V14H13V16H15C15.552 16 16 15.552 16 15V3C16 2.448 15.552 2 15 2Z"
      className="fill"
    />
  </svg>
);

export const Simulate = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1152_27377)">
      <path
        d="M15.4 3.10039L8.4 0.100391C8.1 0.000390626 7.9 0.000390626 7.6 0.100391L0.6 3.10039C0.2 3.20039 0 3.60039 0 4.00039V12.0004C0 12.4004 0.2 12.8004 0.6 12.9004L7.6 15.9004C7.7 16.0004 7.9 16.0004 8 16.0004C8.1 16.0004 8.3 16.0004 8.4 15.9004L15.4 12.9004C15.8 12.7004 16 12.4004 16 12.0004V4.00039C16 3.60039 15.8 3.20039 15.4 3.10039ZM8 2.10039L12.5 4.00039L8 5.90039L3.5 4.00039L8 2.10039ZM2 5.50039L7 7.60039V13.4004L2 11.3004V5.50039ZM9 13.5004V7.70039L14 5.60039V11.4004L9 13.5004Z"
        className="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_1152_27377">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Popup = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1152_27335)">
      <path
        d="M11.5001 8.00651e-07H6.50008C6.40106 -0.000176365 6.30422 0.029052 6.22183 0.0839806C6.13944 0.138909 6.07521 0.217064 6.0373 0.308538C5.99938 0.400011 5.98948 0.500683 6.00884 0.597791C6.02821 0.6949 6.07597 0.784071 6.14608 0.854001L7.93908 2.646L5.29308 5.293C5.19757 5.38525 5.12139 5.49559 5.06898 5.6176C5.01657 5.7396 4.98898 5.87082 4.98783 6.0036C4.98668 6.13638 5.01198 6.26806 5.06226 6.39095C5.11254 6.51385 5.18679 6.6255 5.28069 6.7194C5.37458 6.81329 5.48623 6.88754 5.60913 6.93782C5.73202 6.9881 5.8637 7.01341 5.99648 7.01225C6.12926 7.0111 6.26048 6.98351 6.38249 6.9311C6.50449 6.87869 6.61483 6.80251 6.70708 6.707L9.35408 4.061L11.1461 5.854C11.1926 5.9004 11.2478 5.93718 11.3086 5.96223C11.3693 5.98728 11.4344 6.00012 11.5001 6C11.5656 5.99967 11.6304 5.98677 11.6911 5.962C11.7825 5.92421 11.8607 5.86013 11.9157 5.77789C11.9707 5.69565 12.0001 5.59894 12.0001 5.5V0.500001C12.0001 0.367393 11.9474 0.240216 11.8536 0.146447C11.7599 0.0526792 11.6327 8.00651e-07 11.5001 8.00651e-07Z"
        className="fill"
      />
      <path
        d="M11 8C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9V10H2V2H3C3.26522 2 3.51957 1.89464 3.70711 1.70711C3.89464 1.51957 4 1.26522 4 1C4 0.734784 3.89464 0.48043 3.70711 0.292893C3.51957 0.105357 3.26522 0 3 0L2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8Z"
        className="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_1152_27335">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserModern = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M12.311 9.527C11.15 9.134 10.461 8.702 10.168 8.352C11.268 7.639 12 6.406 12 5V4C12 1.794 10.206 0 8 0C5.794 0 4 1.794 4 4V5C4 6.406 4.732 7.639 5.832 8.352C5.54 8.702 4.851 9.134 3.69 9.527C2.081 10.07 1 11.57 1 13.26V16H15V13.26C15 11.57 13.919 10.07 12.311 9.527ZM6 4C6 2.897 6.897 2 8 2C9.103 2 10 2.897 10 4V5C10 6.103 9.103 7 8 7C6.897 7 6 6.103 6 5V4ZM13 14H3V13.26C3 12.429 3.534 11.691 4.33 11.422C6.175 10.798 7.33 9.986 7.782 9H8.218C8.67 9.986 9.825 10.798 11.671 11.422C12.466 11.69 13 12.429 13 13.26V14Z"
      className="fill"
    />
  </svg>
);

export const UserMinimal = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_5373_24815)">
      <path
        d="M20.8451 20.1029C16.2434 20.1029 12.5117 16.3712 12.5117 11.7695V10.1029C12.5117 5.5012 16.2434 1.76953 20.8451 1.76953C25.4467 1.76953 29.1784 5.5012 29.1784 10.1029V11.7695C29.1784 16.3712 25.4467 20.1029 20.8451 20.1029Z"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        className="stroke"
      />
      <path
        d="M37.512 34.9495C37.512 31.9495 35.517 29.3112 32.622 28.5229C29.4654 27.6612 25.1554 26.7695 20.8454 26.7695C16.5354 26.7695 12.2254 27.6612 9.06871 28.5229C6.17371 29.3112 4.17871 31.9495 4.17871 34.9495V38.4362H37.512V34.9495Z"
        className="stroke"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_5373_24815">
        <rect
          width="40"
          height="40"
          className="fill"
          transform="translate(0.845703 0.101562)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Blank = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="28"
    height="34"
    viewBox="0 0 28 34"
    fill="none"
    {...props}
  >
    <path
      d="M26.6399 1H1.33789V33H26.6399V1Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6.1748 17H7.6628"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M8.26465 11.6482L9.23765 12.6212"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.6172 9.55811V11.0461"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.9681 11.6482L17.9951 12.6212"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.0573 17H19.5693"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.9681 22.3512L17.9951 21.3782"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.6172 24.4411V22.9531"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M8.26465 22.3512L9.23765 21.3782"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const OptimizationNoColor = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.328"
    height="17.971"
    viewBox="0 0 15.328 17.971"
    className={classnames("icon", className)}
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path
        className="stroke"
        strokeLinejoin="round"
        d="M9.568 4.009L5.76 13.91"
      />
      <path
        className="stroke"
        d="M3.285 6.294L1 8.579l2.285 2.285"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M12.043 6.294l2.285 2.285-2.285 2.285"
        strokeLinejoin="round"
      />
      <path className="stroke" d="M1.579 1h12.135" />
      <path className="stroke" d="M1.579 16.971h12.135" />
    </g>
  </svg>
);

export const CapitalProjectNoColor = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.5"
    height="16"
    viewBox="0 0 12.5 16"
    className={classnames("icon", className)}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M4.781 15.5H.969A.968.968 0 0 1 0 14.531V5.812a.965.965 0 0 1 .284-.685L5.128.284a.968.968 0 0 1 1.37 0l4.844 4.844A.97.97 0 1 1 9.971 6.5L5.813 2.339 1.938 6.214v7.349h2.843a.969.969 0 0 1 0 1.938z"
    />
    <path
      className="fill"
      d="M7.125 9.438H12.5v6.563l-2.721-2.534-2.654 2.534z"
    />
  </svg>
);

export const AddDocuments = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="11"
    height="13"
    viewBox="0 0 11 13"
    fill="none"
    {...props}
  >
    <path
      d="M10 12H1V1H7L10 4V12Z"
      className="stroke"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="5.5" y1="5" x2="5.5" y2="10" stroke="white" className="stroke" />
    <line x1="8" y1="7.5" x2="3" y2="7.5" stroke="white" className="stroke" />
    <path
      className="stroke"
      d="M7 1V4H10"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path className="stroke" d="M7 1V4H10L7 1Z" fill="white" />
  </svg>
);

export const BackpackProjects = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M19 2H5"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M22 6H2L5 22H19L22 6Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Marketplace = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M9.18213 20.6529V15.252H12.8181V20.6529"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.76904 9.10156V20.6521H19.23V9.10156"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 6.40099C20.9809 7.13352 20.6696 7.82875 20.1342 8.3347C19.5989 8.84064 18.8829 9.11615 18.143 9.10099C17.6771 9.10435 17.2173 8.99618 16.8027 8.78569C16.3882 8.5752 16.0311 8.26863 15.762 7.89208C15.4905 8.26619 15.1329 8.57094 14.7189 8.78115C14.3049 8.99137 13.8463 9.10101 13.381 9.10101C12.9157 9.10101 12.4571 8.99137 12.0431 8.78115C11.6291 8.57094 11.2715 8.26619 11 7.89208C10.7285 8.26619 10.3709 8.57094 9.95691 8.78115C9.54289 8.99137 9.08429 9.10101 8.619 9.10101C8.15371 9.10101 7.69511 8.99137 7.28109 8.78115C6.86707 8.57094 6.50952 8.26619 6.238 7.89208C5.96888 8.26863 5.61183 8.5752 5.19727 8.78569C4.7827 8.99618 4.32289 9.10435 3.857 9.10099C3.11706 9.11615 2.40115 8.84064 1.86578 8.3347C1.33041 7.82875 1.01914 7.13352 1 6.40099L4.636 1H17.364L21 6.40099Z"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdminUser = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <path
      d="M10.3859 12.1515C7.79288 12.1515 5.69287 9.14257 5.69287 6.57624V5.64653C5.69287 4.4142 6.18731 3.23233 7.06742 2.36094C7.94753 1.48954 9.14122 1 10.3859 1V1C11.6305 1 12.8242 1.48954 13.7043 2.36094C14.5844 3.23233 15.0789 4.4142 15.0789 5.64653V6.57624C15.0789 9.14257 12.9779 12.1515 10.3859 12.1515Z"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.008 14.542L10.386 14.4746C8.00457 14.4711 5.635 14.8065 3.35 15.4707C2.67099 15.6701 2.0753 16.0816 1.65179 16.6436C1.22828 17.2057 0.999651 17.8882 1 18.5895V20.5142H11.325"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.817 16.5106L20.683 16.3859C20.6157 16.1512 20.5214 15.925 20.402 15.7116L21.115 14.8294C21.1738 14.7569 21.2034 14.6655 21.1982 14.5726C21.1931 14.4798 21.1535 14.3921 21.087 14.3265L20.548 13.7918C20.4817 13.726 20.3931 13.6868 20.2994 13.6817C20.2056 13.6766 20.1133 13.7059 20.04 13.7641L19.149 14.472C18.9336 14.3535 18.7051 14.2598 18.468 14.1928L18.342 13.07C18.3316 12.9773 18.287 12.8918 18.2166 12.8298C18.1463 12.7678 18.0552 12.7338 17.961 12.7344H17.202C17.1078 12.7338 17.0168 12.7678 16.9464 12.8298C16.8761 12.8918 16.8314 12.9773 16.821 13.07L16.693 14.1928C16.456 14.2598 16.2275 14.3535 16.012 14.472L15.121 13.7661C15.0478 13.7079 14.9554 13.6786 14.8617 13.6837C14.7679 13.6888 14.6794 13.728 14.613 13.7938L14.071 14.3275C14.0046 14.3931 13.965 14.4808 13.9598 14.5736C13.9546 14.6665 13.9843 14.7579 14.043 14.8304L14.758 15.7126C14.6383 15.9259 14.5437 16.1522 14.476 16.3869L13.341 16.5106C13.2466 16.521 13.1594 16.5659 13.0967 16.6366C13.034 16.7073 13.0002 16.7987 13.002 16.8928V17.6482C13.0014 17.7415 13.0358 17.8316 13.0984 17.9013C13.161 17.971 13.2474 18.0152 13.341 18.0255L14.475 18.1502C14.5427 18.3849 14.6373 18.6111 14.757 18.8245L14.044 19.7047C13.9853 19.7772 13.9556 19.8686 13.9608 19.9615C13.966 20.0543 14.0056 20.142 14.072 20.2076L14.611 20.7413C14.6774 20.8071 14.7659 20.8463 14.8597 20.8514C14.9534 20.8565 15.0458 20.8272 15.119 20.769L16.011 20.0611C16.2265 20.1797 16.455 20.2734 16.692 20.3403L16.816 21.4621C16.8264 21.5548 16.8711 21.6404 16.9414 21.7023C17.0118 21.7643 17.1028 21.7983 17.197 21.7977H17.96C18.0542 21.7983 18.1453 21.7643 18.2156 21.7023C18.286 21.6404 18.3306 21.5548 18.341 21.4621L18.467 20.3393C18.7044 20.2727 18.9332 20.1794 19.149 20.0611L20.04 20.7671C20.1133 20.8252 20.2056 20.8546 20.2994 20.8494C20.3931 20.8443 20.4817 20.8051 20.548 20.7393L21.087 20.2057C21.1535 20.14 21.1931 20.0523 21.1982 19.9595C21.2034 19.8667 21.1738 19.7752 21.115 19.7027L20.402 18.8185C20.5218 18.6052 20.6164 18.379 20.684 18.1443L21.817 18.0215C21.9106 18.0112 21.9971 17.967 22.0597 17.8973C22.1223 17.8277 22.1566 17.7375 22.156 17.6443V16.8928C22.1579 16.7987 22.1241 16.7073 22.0614 16.6366C21.9986 16.5659 21.9115 16.521 21.817 16.5106ZM17.579 18.774C17.277 18.7746 16.9815 18.6864 16.7301 18.5206C16.4787 18.3548 16.2826 18.1189 16.1668 17.8427C16.0509 17.5665 16.0204 17.2624 16.0792 16.9691C16.138 16.6757 16.2834 16.4062 16.497 16.1947C16.7106 15.9833 16.9828 15.8393 17.2791 15.7811C17.5753 15.7229 17.8824 15.7531 18.1614 15.8678C18.4403 15.9825 18.6786 16.1766 18.8461 16.4255C19.0135 16.6745 19.1026 16.967 19.102 17.2661C19.1012 17.6657 18.9405 18.0488 18.6551 18.3315C18.3696 18.6141 17.9827 18.7732 17.579 18.774Z"
      className="fill"
    />
  </svg>
);

export const MenuSquares = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <path
      d="M8.00195 1H1.00195V8H8.00195V1Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.002 1H14.002V8H21.002V1Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M8.00195 14H1.00195V21H8.00195V14Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.002 14H14.002V21H21.002V14Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BackpackLogoNegative = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="25"
    height="30"
    viewBox="0 0 25 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3369_25804)">
      <path
        d="M18.0041 11.9988H0.00289408V11.1586H18.0012V6.00039C18.0012 2.68667 15.3145 0 12.0008 0H0V12.0008H0.00289408V30H18.0041V11.9988Z"
        className="fill"
      />
      <path
        d="M18.8442 12.0596V29.9401C21.7595 29.5301 24.0024 27.0277 24.0024 23.9996V17.9992C24.0024 14.971 21.7595 12.4686 18.8442 12.0586V12.0596Z"
        className="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_3369_25804">
        <rect width="24.0015" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FirstName = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path
      d="M15 1H1V13H15V1Z"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 5.5H11.5" className="stroke" strokeWidth="2" />
  </svg>
);

export const LastName = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path
      d="M15 1H1V13H15V1Z"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 8.5H11.5" className="stroke" strokeWidth="2" />
  </svg>
);

export const Email = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path
      d="M15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0ZM14 12H2V5.723L7.5 8.868C7.65106 8.95429 7.82203 8.99968 7.996 8.99968C8.16997 8.99968 8.34093 8.95429 8.492 8.868L14 5.723V12ZM14 3.42L8 6.849L2 3.42V2H14V3.42Z"
      className="fill"
    />
  </svg>
);

export const EmailCheck = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <path
      d="M12 2L6 6L0 2V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893C11.8946 0.48043 12 0.734784 12 1V2Z"
      className="fill"
    />
    <rect x="10" y="2" width="2" height="4" className="fill" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 8.00078H2V3.13678L0 1.80078V9.00078C0 9.266 0.105357 9.52035 0.292893 9.70789C0.48043 9.89542 0.734784 10.0008 1 10.0008H5V8.00078Z"
      className="fill"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5915 11.5054L12.8024 8.29456L11.7416 7.23377L8.53072 10.4446L7.05867 8.97258L6.00108 10.0302L7.47313 11.5022L7.47278 11.5026L8.53356 12.5634L8.53391 12.563L8.53424 12.5633L9.59184 11.5058L9.5915 11.5054Z"
      className="fill"
    />
  </svg>
);

export const InfoSmall = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 4L7 7"
      className="stroke"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z"
      className="fill"
    />
  </svg>
);

export const BuildingCity = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M6.8999 7C7.72833 7 8.3999 6.32843 8.3999 5.5C8.3999 4.67157 7.72833 4 6.8999 4C6.07148 4 5.3999 4.67157 5.3999 5.5C5.3999 6.32843 6.07148 7 6.8999 7Z"
        className="fill"
      />
      <path
        d="M6.42702 10.577C6.36602 10.516 3.88202 8.33501 3.88202 8.27701C3.46696 7.90339 3.13812 7.44398 2.9183 6.93062C2.69849 6.41725 2.59295 5.86222 2.60902 5.30401C2.60556 4.74598 2.71293 4.19281 2.92489 3.67659C3.13684 3.16037 3.44918 2.69136 3.84377 2.29676C4.23837 1.90217 4.70738 1.58984 5.2236 1.37788C5.73982 1.16592 6.29298 1.05856 6.85102 1.06201C7.40913 1.05842 7.9624 1.16569 8.47874 1.37759C8.99508 1.58949 9.4642 1.9018 9.85891 2.29641C10.2536 2.69102 10.566 3.16007 10.7781 3.67636C10.9901 4.19264 11.0975 4.74589 11.094 5.30401C11.1039 5.86977 10.9958 6.43139 10.7766 6.95307C10.5574 7.47475 10.232 7.94505 9.82102 8.33401C9.76002 8.39501 7.33602 10.576 7.27602 10.634C7.15136 10.7284 6.99685 10.7745 6.84087 10.7641C6.68489 10.7536 6.53794 10.6872 6.42702 10.577V10.577Z"
        stroke="currentColor"
        strokeWidth="2"
        className="stroke"
      />
      <path
        d="M10.1 12C11.712 12.291 12.778 12.8 12.778 13.368C12.778 14.268 10.141 15 6.887 15C3.633 15 1 14.27 1 13.368C1 12.795 2.066 12.291 3.678 12"
        className="stroke"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export const BuildingState = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M14.1 8.949C14.1 10.1459 13.7451 11.3158 13.0801 12.311C12.4152 13.3061 11.47 14.0817 10.3642 14.5396C9.25841 14.9975 8.04166 15.1172 6.86782 14.8836C5.69399 14.6499 4.61581 14.0734 3.76964 13.227C2.92347 12.3805 2.34733 11.3022 2.11407 10.1283C1.88082 8.95435 2.00094 7.73763 2.45923 6.63199C2.91752 5.52635 3.6934 4.58145 4.68875 3.9168C5.68409 3.25215 6.85419 2.8976 8.05105 2.898C8.34554 2.89814 8.63964 2.91953 8.93105 2.962"
        className="stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.4972 4.108C13.4972 5.602 11.0772 7.739 11.0772 7.739C11.0772 7.739 8.65625 5.602 8.65625 4.108C8.65625 3.46604 8.91127 2.85038 9.3652 2.39645C9.81913 1.94252 10.4348 1.6875 11.0767 1.6875C11.7187 1.6875 12.3344 1.94252 12.7883 2.39645C13.2422 2.85038 13.4972 3.46604 13.4972 4.108V4.108Z"
        className="stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const BuildingZipcode = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M1.02686 4.813L7.25286 10.473L10.8839 7.173"
        className="stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 10.883V15.004H1V4.004H9.6"
        className="stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.4968 4.10699C14.4968 5.60099 12.0768 7.73799 12.0768 7.73799C12.0768 7.73799 9.65576 5.60099 9.65576 4.10699C9.65576 3.46504 9.91078 2.84937 10.3647 2.39544C10.8186 1.94151 11.4343 1.68649 12.0763 1.68649C12.7182 1.68649 13.3339 1.94151 13.7878 2.39544C14.2417 2.84937 14.4968 3.46504 14.4968 4.10699V4.10699Z"
        className="stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const CircledClear = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10.1 4.5L8 6.6L5.9 4.5L4.5 5.9L6.6 8L4.5 10.1L5.9 11.5L8 9.4L10.1 11.5L11.5 10.1L9.4 8L11.5 5.9L10.1 4.5Z"
      className="fill"
    />
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
      className="fill"
    />
  </svg>
);

export const CompletenessMenu = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1101_38929)">
      <path
        d="M12.8346 2.16602H1.16797V6.83268H12.8346V2.16602Z"
        className="stroke"
        strokeWidth="2"
      />
      <path
        d="M1.16797 6.83203H12.8346V13.0543H1.16797V6.83203Z"
        className="stroke"
        strokeWidth="2"
      />
      <path d="M5.05664 6.83301V9.94412" className="stroke" strokeWidth="2" />
      <path d="M8.94531 6.83301V9.94412" className="stroke" strokeWidth="2" />
    </g>
    <defs>
      <clipPath id="clip0_1101_38929">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Ban = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 2C9.3 2 10.5 2.4 11.5 3.1L3.1 11.5C2.4 10.5 2 9.3 2 8C2 4.7 4.7 2 8 2ZM8 14C6.7 14 5.5 13.6 4.5 12.9L12.9 4.5C13.6 5.5 14 6.7 14 8C14 11.3 11.3 14 8 14Z"
      className="fill"
    />
  </svg>
);

export const OutlinedStar = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_5868_30652)">
      <path
        d="M11.8596 15.5429L7.99957 13.5139L4.13956 15.5429C3.41256 15.9299 2.54757 15.3079 2.68857 14.4889L3.42557 10.1899L0.301565 7.14592C-0.292435 6.56592 0.0385652 5.55892 0.856565 5.43992L5.17256 4.81292L7.10357 0.900922C7.43957 0.217922 8.56057 0.217922 8.89657 0.900922L10.8276 4.81192L15.1436 5.43892C15.9616 5.55792 16.2916 6.56492 15.6986 7.14492L12.5746 10.1899L13.3116 14.4889C13.4526 15.3119 12.5856 15.9249 11.8596 15.5429ZM8.46556 11.4989L10.9976 12.8299L10.5146 10.0099C10.4586 9.68592 10.5666 9.35492 10.8016 9.12492L12.8506 7.12692L10.0196 6.71592C9.69257 6.66892 9.41157 6.46392 9.26657 6.16892L7.99957 3.60292L6.73256 6.16892C6.58656 6.46392 6.30557 6.66892 5.97957 6.71592L3.14857 7.12692L5.19757 9.12492C5.43257 9.35392 5.54057 9.68592 5.48457 10.0099L5.00156 12.8299L7.53357 11.4989C7.82557 11.3449 8.17356 11.3449 8.46556 11.4989Z"
        className="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_5868_30652">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// customizable with default color override

// needed for Console app to overwrite icon color in Input
export const CalendarCharcoal = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={classnames("icon", "color-icon--charcoal", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M15 2h-2V0h-3v2H6V0H3v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-1 12H2V7h12z"
    />
  </svg>
);

export const EnergyStar = ({
  className,
  loading,
  ...props
}: ComponentProps<"svg"> & { loading?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.428"
    height="16.18"
    viewBox="0 0 19.428 16.18"
    preserveAspectRatio="xMidYMid meet"
    className={classnames(
      "icon",
      "color-icon--yellow",
      className,
      loading && "loading-icon"
    )}
    {...props}
  >
    <g>
      <path
        className="stroke"
        d="M3.239 6.541l5.078-.738 2.271-4.6 2.271 4.6 5.078.738-3.675 3.582.867 5.058-4.54-2.388-4.542 2.387.867-5.058"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M4.41825241 12.472c-.83570558.09451546-1.5448593-.0537748-1.8053593-.50497404-.6885-1.19251698 2.02657602-4.04986736 6.06398646-6.38086736S16.5455 2.33300898 17.234 3.52552596a1.509 1.509 0 01-.04895499 1.09520747"
      />
      {loading && (
        <>
          <mask id="mask0">
            <path
              className="stroke"
              d="M3.239 6.541l5.078-.738 2.271-4.6 2.271 4.6 5.078.738-3.675 3.582.867 5.058-4.54-2.388-4.542 2.387.867-5.058"
              strokeLinejoin="round"
              strokeLinecap="round"
              style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#C4C4C4",
              }}
            />
          </mask>
          <rect
            mask="url(#mask0)"
            x="3"
            width="20"
            style={{ fill: "#FFD630" }}
          />
        </>
      )}
    </g>
  </svg>
);

export const InvalidAltOutline = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || "color-icon--red"}
    {...props}
  >
    <path
      d="M10.1 4.5L8 6.6L5.9 4.5L4.5 5.9L6.6 8L4.5 10.1L5.9 11.5L8 9.4L10.1 11.5L11.5 10.1L9.4 8L11.5 5.9L10.1 4.5Z"
      fill="#FB4E77"
    />
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
      fill="#FB4E77"
    />
  </svg>
);

export const InvalidAlt = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    className={className || "color-icon--red"}
    {...props}
  >
    <path
      className="fill"
      d="M6.5,0A6.5,6.5,0,1,0,13,6.5,6.508,6.508,0,0,0,6.5,0Z"
    />
    <g transform="translate(3.875 3.875)">
      <line
        stroke="white"
        strokeWidth="2px"
        x1="5"
        y2="5"
        transform="translate(0.25 0.25)"
      />
      <line
        stroke="white"
        strokeWidth="2px"
        x1="5"
        y1="5"
        transform="translate(0.25 0.25)"
      />
    </g>
  </svg>
);

export const Valid = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    className={classnames("icon", "color-icon--green", className)}
    {...props}
  >
    <path
      className="fill"
      d="M8 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8zm0 14a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6z"
    />
    <g transform="translate(3.5,4.5)">
      <path
        className="fill"
        d="M3.414 6.828L0 3.414 1.414 2l2 2 4-4 1.414 1.414z"
      />
    </g>
  </svg>
);

export const ValidAlt = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    preserveAspectRatio="xMidYMid meet"
    className={classnames("color-icon--green", className)}
    {...props}
  >
    <circle cx="6.5" cy="6.5" r="6.5" className="fill" />
    <g transform="translate(2.25,3.5)" fill="white">
      <path
        fill="white"
        d="M3.414 6.828L0 3.414 1.414 2l2 2 4-4 1.414 1.414z"
      />
    </g>
  </svg>
);

export const Invalid = ({
  className,
  innerRef,
  ...props
}: ComponentProps<"svg"> & { innerRef?: React.LegacyRef<SVGSVGElement> }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15.956"
    viewBox="0 0 16 15.956"
    preserveAspectRatio="xMidYMid meet"
    className={className || "color-icon--yellow"}
    ref={innerRef}
    {...props}
  >
    <path
      className="fill"
      d="M15.001 15.956h-14a1 1 0 0 1-.9-1.448l7-14a1.041 1.041 0 0 1 1.789 0l7 14a1 1 0 0 1-.889 1.448zm-12.382-2h10.764L8.001 3.192z"
    />
    <g transform="translate(7,6)">
      <path className="fill" d="M0 0h2v4H0z" />
    </g>

    <g transform="translate(7,11)">
      <circle className="fill" cx="1" cy="1" r="1" />
    </g>
  </svg>
);

export const PDF = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classnames("icon", "color-icon--red", className)}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path d="M20 1v8h8" className="stroke" strokeMiterlimit="10" />
    <path
      d="M28 13V9l-8-8H4v12"
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M4 27v4h24v-4"
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      className="fill"
      d="M13.143 19.1a1.915 1.915 0 0 1-.564 1.479 2.276 2.276 0 0 1-1.6.521h-.434V23H9v-5.711h1.977a2.412 2.412 0 0 1 1.625.473 1.685 1.685 0 0 1 .541 1.338zm-2.6.743h.281a.77.77 0 0 0 .553-.195.708.708 0 0 0 .2-.539q0-.579-.641-.578h-.4z"
    />
    <path
      className="fill"
      d="M18.9 20.023a2.948 2.948 0 0 1-.787 2.2A3.026 3.026 0 0 1 15.9 23h-1.848v-5.711h1.977a2.979 2.979 0 0 1 2.123.7 2.657 2.657 0 0 1 .748 2.034zm-1.6.055a1.817 1.817 0 0 0-.311-1.164 1.146 1.146 0 0 0-.943-.379H15.6v3.2h.344a1.244 1.244 0 0 0 1.031-.408 1.97 1.97 0 0 0 .325-1.249z"
    />
    <path
      className="fill"
      d="M21.443 23h-1.52v-5.711H23.3v1.238h-1.857v1.09h1.711v1.238h-1.711z"
    />
    <path
      className="stroke"
      strokeLinecap="square"
      strokeMiterlimit="10"
      d="M1 13h30v14H1z"
    />
  </svg>
);

export const Docx = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classnames("icon", "color-icon--blue", className)}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path className="stroke" d="M20 1v8h8" strokeMiterlimit="10" />
    <path
      d="M28 13V9l-8-8H4v12"
      strokeLinecap="square"
      strokeMiterlimit="10"
      className="stroke"
    />
    <path
      d="M4 27v4h24v-4"
      strokeLinecap="square"
      strokeMiterlimit="10"
      className="stroke"
    />
    <path
      className="fill"
      d="M9.9 20a2.947 2.947 0 0 1-.8 2.2 3.113 3.113 0 0 1-2.2.8H5v-5.7h2a2.817 2.817 0 0 1 2.1.7 2.629 2.629 0 0 1 .8 2zm-1.6.1a2.133 2.133 0 0 0-.3-1.2 1.159 1.159 0 0 0-1-.4h-.5v3.2h.3a1.053 1.053 0 0 0 1-.4 2.2 2.2 0 0 0 .5-1.2z"
    />
    <path
      className="fill"
      d="M16.2 20.1a2.918 2.918 0 0 1-.7 2.2 2.865 2.865 0 0 1-2.1.8 2.865 2.865 0 0 1-2.1-.8 2.918 2.918 0 0 1-.7-2.2 2.918 2.918 0 0 1 .7-2.2 2.865 2.865 0 0 1 2.1-.8 2.817 2.817 0 0 1 2.1.7 3.334 3.334 0 0 1 .7 2.3zm-3.9 0c0 1.1.4 1.7 1.2 1.7a.975.975 0 0 0 .9-.4 2.269 2.269 0 0 0 .3-1.3 2.269 2.269 0 0 0-.3-1.3.975.975 0 0 0-.9-.4c-.8.1-1.2.6-1.2 1.7z"
    />
    <path
      className="fill"
      d="M19.8 18.5a1.05 1.05 0 0 0-.9.5 2.133 2.133 0 0 0-.3 1.2c0 1.1.4 1.6 1.3 1.6a1.483 1.483 0 0 0 .7-.1c.2-.1.5-.2.7-.3v1.3a4.146 4.146 0 0 1-1.6.3 2.319 2.319 0 0 1-2-.8 2.724 2.724 0 0 1-.7-2 4.146 4.146 0 0 1 .3-1.6 1.651 1.651 0 0 1 1-1 3.707 3.707 0 0 1 1.5-.4 3.922 3.922 0 0 1 1.8.4l-.5 1.2a1.421 1.421 0 0 0-.6-.2c-.2 0-.5-.1-.7-.1z"
    />
    <path
      className="fill"
      d="M27.6 23h-1.8l-1.1-1.8-1.1 1.8h-1.7l1.9-2.9-1.8-2.8h1.7l1 1.8 1-1.8h1.8l-1.8 2.9z"
    />
    <path
      strokeLinecap="square"
      strokeMiterlimit="10"
      d="M1 13h30v14H1z"
      className="stroke"
    />
  </svg>
);

export const CapitalProject = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.5"
    height="16"
    viewBox="0 0 12.5 16"
    className={classnames("icon", "color-icon--green", className)}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M4.781 15.5H.969A.968.968 0 0 1 0 14.531V5.812a.965.965 0 0 1 .284-.685L5.128.284a.968.968 0 0 1 1.37 0l4.844 4.844A.97.97 0 1 1 9.971 6.5L5.813 2.339 1.938 6.214v7.349h2.843a.969.969 0 0 1 0 1.938z"
    />
    <path
      className="fill"
      d="M7.125 9.438H12.5v6.563l-2.721-2.534-2.654 2.534z"
    />
  </svg>
);

export const Optimization = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.328"
    height="17.971"
    viewBox="0 0 15.328 17.971"
    className={classnames("icon", "color-icon--yellow", className)}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g strokeLinecap="round">
      <path
        className="stroke"
        strokeLinejoin="round"
        d="M9.568 4.009L5.76 13.91"
      />
      <path
        className="stroke"
        d="M3.285 6.294L1 8.579l2.285 2.285"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M12.043 6.294l2.285 2.285-2.285 2.285"
        strokeLinejoin="round"
      />
      <path className="stroke" d="M1.579 1h12.135" />
      <path className="stroke" d="M1.579 16.971h12.135" />
    </g>
  </svg>
);

export const BASUpgrade = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.463"
    height="15.463"
    viewBox="0 0 15.463 15.463"
    className={classnames("icon", "color-icon--blue", className)}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      className="fill"
      d="M5.8 0H.966A.967.967 0 0 0 0 .966V5.8a.967.967 0 0 0 .966.966H5.8a.967.967 0 0 0 .965-.966V.966A.967.967 0 0 0 5.8 0z"
    />
    <path
      className="fill"
      d="M5.8 8.698H.966A.967.967 0 0 0 0 9.664v4.834a.967.967 0 0 0 .966.966H5.8a.967.967 0 0 0 .966-.966V9.664a.967.967 0 0 0-.966-.966zm-3.867 1.933h2.9v2.9h-2.9z"
    />
    <path
      className="fill"
      d="M12.563 4.832V14.5a.967.967 0 0 1-.966.966.967.967 0 0 1-.966-.966V4.832h-2.9L11.597 0l3.866 4.832z"
    />
  </svg>
);

// static

export const LeedThin = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3561_4277)">
      <path
        d="M0 11.0703H19.9186C22.1374 11.0708 24.2651 11.9525 25.8338 13.5215C27.4025 15.0906 28.2838 17.2185 28.2838 19.4373C28.2838 21.656 27.4025 23.7839 25.8338 25.353C24.2651 26.922 22.1374 27.8037 19.9186 27.8042C18.8199 27.8042 17.732 27.5878 16.717 27.1673C15.7019 26.7468 14.7797 26.1304 14.0029 25.3535C13.2261 24.5765 12.6099 23.6541 12.1896 22.639C11.7694 21.6239 11.5533 20.536 11.5535 19.4373V17.031"
        stroke="#C9C4BB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M0 1.76953H20.1061C22.4867 1.76976 24.8439 2.23889 27.0433 3.15013C29.2426 4.06136 31.2409 5.39687 32.9241 7.08038C34.6073 8.76389 35.9424 10.7625 36.8532 12.9619C37.764 15.1614 38.2326 17.5188 38.2324 19.8994C38.2326 22.28 37.764 24.6374 36.8532 26.8369C35.9424 29.0363 34.6073 31.0349 32.9241 32.7184C31.2409 34.4019 29.2426 35.7374 27.0433 36.6487C24.8439 37.5599 22.4867 38.029 20.1061 38.0293C15.2985 38.0283 10.6882 36.1178 7.28923 32.7178C3.89027 29.3178 1.98112 24.707 1.98159 19.8994V17.2119"
        stroke="#C9C4BB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_3561_4277">
        <rect width="40" height="39.8001" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OpenBackpack = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    {...props}
  >
    <path
      d="M70.3339 25.4453H12.1279V70.1463H70.3339V25.4453Z"
      stroke="#88CCCA"
      strokeWidth="2"
    />
    <path
      d="M23.5981 1.85742V4.53842"
      stroke="#88CCCA"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M33.228 37.166V39.847"
      stroke="#88CCCA"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M39.647 1.85742V4.53842"
      stroke="#88CCCA"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M49.2769 37.166V39.847"
      stroke="#88CCCA"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path d="M55.6952 19.3047H2.20117" stroke="#88CCCA" strokeWidth="2" />
    <path
      d="M6.80202 25.4446C5.43986 25.4446 4.1335 24.9035 3.17032 23.9403C2.20713 22.9771 1.66602 21.6707 1.66602 20.3086V64.9146C1.66602 66.3019 2.21714 67.6325 3.19814 68.6135C4.17914 69.5945 5.50967 70.1456 6.89702 70.1456H12.128V25.4456L6.80202 25.4446Z"
      stroke="#88CCCA"
    />
    <path
      d="M6.80202 25.4446C5.43986 25.4446 4.1335 24.9035 3.17032 23.9403C2.20713 22.9771 1.66602 21.6707 1.66602 20.3086V64.9146C1.66602 66.3019 2.21714 67.6325 3.19814 68.6135C4.17914 69.5945 5.50967 70.1456 6.89702 70.1456H12.128V25.4456L6.80202 25.4446Z"
      stroke="#88CCCA"
      strokeWidth="2"
    />
    <path
      d="M65.153 20.3103V4.90234H1.66602V20.3103C1.66602 20.9848 1.79886 21.6527 2.05697 22.2758C2.31508 22.8989 2.69339 23.4651 3.17032 23.942C3.64724 24.419 4.21343 24.7973 4.83655 25.0554C5.45968 25.3135 6.12755 25.4463 6.80202 25.4463H70.289C69.6145 25.4463 68.9467 25.3135 68.3236 25.0554C67.7004 24.7973 67.1342 24.419 66.6573 23.942C66.1804 23.4651 65.8021 22.8989 65.544 22.2758C65.2859 21.6527 65.153 20.9848 65.153 20.3103V20.3103Z"
      stroke="#88CCCA"
      strokeWidth="2"
    />
  </svg>
);

export const CaseStudy = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="66"
    height="72"
    viewBox="0 0 66 72"
    fill="none"
    {...props}
  >
    <path d="M39.0352 1V21.517H59.5522" stroke="#DEC173" strokeWidth="2" />
    <path
      d="M59.5521 34.793V21.517L39.0351 1H1.62109V71H37.8281"
      stroke="#DEC173"
      strokeWidth="2"
    />
    <path d="M27.2873 56.2227H14.8433" stroke="#DEC173" strokeWidth="2" />
    <path d="M27.2873 44.5566H14.8433" stroke="#DEC173" strokeWidth="2" />
    <path d="M45.9543 32.1113H14.8433" stroke="#DEC173" strokeWidth="2" />
    <path d="M28.0653 20.4434H14.8433" stroke="#DEC173" strokeWidth="2" />
    <path
      d="M64.3793 69.7934L54.9863 60.4004"
      stroke="#DEC173"
      strokeWidth="2"
    />
    <path
      d="M46.7319 64.002C53.1754 64.002 58.3989 58.7785 58.3989 52.335C58.3989 45.8915 53.1754 40.668 46.7319 40.668C40.2884 40.668 35.0649 45.8915 35.0649 52.335C35.0649 58.7785 40.2884 64.002 46.7319 64.002Z"
      stroke="#DEC173"
      strokeWidth="2"
    />
  </svg>
);

export const EditLevels = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="72"
    height="66"
    viewBox="0 0 72 66"
    fill="none"
    {...props}
  >
    <path d="M1 65V60L6 56.25L11 60V65H1Z" stroke="#ACB1E2" strokeWidth="2" />
    <path
      d="M31 65V60L36 56.25L41 60V65H31Z"
      stroke="#ACB1E2"
      strokeWidth="2"
    />
    <path
      d="M61 65V60L66 56.25L71 60V65H61Z"
      stroke="#ACB1E2"
      strokeWidth="2"
    />
    <path d="M1 47.5V20" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M31 47.5V22.5" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M61 47.5V7.5" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M71 47.5V0" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M11 47.5V0" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M21 47.5V36.25" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M41 47.5V0" stroke="#ACB1E2" strokeWidth="2" />
    <path d="M51 47.5V22.5" stroke="#ACB1E2" strokeWidth="2" />
  </svg>
);

export const NewConstruction = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="72"
    height="73"
    viewBox="0 0 72 73"
    fill="none"
    {...props}
  >
    <path
      d="M13.069 72.0001H1V40.6211H5.828"
      stroke="#9DBFDD"
      strokeWidth="2"
    />
    <path d="M22.7241 53.8965H32.3791" stroke="#9DBFDD" strokeWidth="2" />
    <path d="M22.7241 46.6543H32.3791" stroke="#9DBFDD" strokeWidth="2" />
    <path d="M22.7241 61.1387H32.3791" stroke="#9DBFDD" strokeWidth="2" />
    <path d="M22.7241 39.4141H32.3791" stroke="#9DBFDD" strokeWidth="2" />
    <path
      d="M37.2068 21.31V2L70.9998 14.069V72H13.0688V28.552H42.0348V71.2"
      stroke="#9DBFDD"
      strokeWidth="2"
    />
    <path d="M49.2759 61.1374V16.4824" stroke="#9DBFDD" strokeWidth="2" />
    <path d="M56.5171 61.1375V18.8965" stroke="#9DBFDD" strokeWidth="2" />
    <path d="M63.7588 61.1385V21.3105" stroke="#9DBFDD" strokeWidth="2" />
  </svg>
);

export const InProcess = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="33"
    height="31"
    viewBox="0 0 33 31"
    fill="none"
    {...props}
  >
    <path d="M31.068 1H1V14.091H31.068V1Z" stroke="#B9C3E1" strokeWidth="2" />
    <path
      d="M2 15.0811V28.9441H30.0679V15.0811H2ZM0 13.0811H32.0679V30.9441H0V13.0811Z"
      fill="#B9C3E1"
    />
    <path d="M11.3223 13.5537V20.7537" stroke="#B9C3E1" strokeWidth="2" />
    <path d="M20.7539 13.5537V20.7537" stroke="#B9C3E1" strokeWidth="2" />
    <path d="M31.0679 29.9453H1V1.00391H31.0679V29.9453Z" fill="#8EEACE" />
    <path
      d="M2 2.00391V28.9453H30.0679V2.00391H2ZM0 0.00390625H32.0679V30.9453H0V0.00390625Z"
      fill="#00CC8F"
    />
    <path d="M11.3223 13.5547V20.7546" stroke="#00CC8F" strokeWidth="2" />
    <path d="M20.7539 13.5547V20.7546" stroke="#00CC8F" strokeWidth="2" />
    <path
      d="M31.068 1.00098H1V14.092H31.068V1.00098Z"
      stroke="#00CC8F"
      strokeWidth="2"
    />
  </svg>
);

export const Analyze = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="40"
    viewBox="0 0 38 40"
    fill="none"
    {...props}
  >
    <path
      d="M36.1247 39.322L31.9688 35.166"
      stroke="#4C516A"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M8.08057 18.8412H13.6873L16.4909 13.4941L20.2287 24.1883L23.0324 18.8412H28.6391"
      stroke="#00CC8F"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M18.5418 36.1247C28.2526 36.1247 36.1247 28.2526 36.1247 18.5418C36.1247 8.83109 28.2526 0.958984 18.5418 0.958984C8.83109 0.958984 0.958984 8.83109 0.958984 18.5418C0.958984 28.2526 8.83109 36.1247 18.5418 36.1247Z"
      stroke="#4C516A"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const Optimize = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2992_25956)">
      <path
        d="M3.3799 34.7397L2.6499 28.9297L8.3499 30.5197"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.12988 28.7502C5.09959 32.5099 8.27141 35.5017 12.1396 37.2487C16.0077 38.9957 20.3494 39.3972 24.4723 38.3892C28.5952 37.3812 32.2619 35.0217 34.8877 31.687C37.5134 28.3524 38.947 24.2346 38.9599 19.9902"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.5901 5.25977L37.3201 11.0698L31.6201 9.47976"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M36.83 11.2392C34.8603 7.47954 31.6885 4.4877 27.8203 2.74073C23.9522 0.993755 19.6105 0.592255 15.4875 1.60026C11.3646 2.60826 7.69796 4.96772 5.0722 8.30237C2.44645 11.637 1.01284 15.7548 1 19.9992"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.9799 23.4499C20.6503 23.4499 21.3057 23.2511 21.8632 22.8786C22.4207 22.5061 22.8552 21.9767 23.1118 21.3572C23.3684 20.7378 23.4355 20.0562 23.3047 19.3986C23.1739 18.741 22.8511 18.1369 22.377 17.6628C21.9029 17.1887 21.2988 16.8659 20.6412 16.7351C19.9836 16.6043 19.302 16.6714 18.6826 16.928C18.0631 17.1845 17.5337 17.6191 17.1612 18.1765C16.7887 18.734 16.5898 19.3894 16.5898 20.0599C16.5898 20.959 16.947 21.8213 17.5828 22.457C18.2185 23.0928 19.0808 23.4499 19.9799 23.4499V23.4499Z"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M27.9198 20.0597C27.9226 19.4876 27.8588 18.9171 27.7298 18.3597L30.4298 16.3597L28.4298 12.9197L25.3098 14.2297C24.465 13.4561 23.4617 12.8759 22.3698 12.5297L21.9598 9.17969H17.9598L17.5498 12.5297C16.4579 12.8759 15.4546 13.4561 14.6098 14.2297L11.5298 12.8797L9.52979 16.3097L12.2198 18.3097C11.9799 19.4303 11.9799 20.5891 12.2198 21.7097L9.52979 23.7097L11.5298 27.1497L14.6498 25.8297C15.494 26.6064 16.4973 27.1899 17.5898 27.5397L17.9998 30.8897H21.9998L22.4098 27.5397C23.5023 27.1899 24.5056 26.6064 25.3498 25.8297L28.4798 27.1497L30.4798 23.7097L27.7898 21.7097C27.9095 21.1509 27.9698 20.5811 27.9698 20.0097L27.9198 20.0597Z"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_2992_25956">
        <rect width="39.97" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Stopwatch = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7 0.3C12.3 -0.1 11.7 -0.1 11.3 0.3C10.9 0.7 10.9 1.3 11.3 1.7L12.1 2.5L11.2 3.4C10 2.5 8.6 2 7 2C3.1 2 0 5.1 0 9C0 12.9 3.1 16 7 16C10.9 16 14 12.9 14 9C14 7.4 13.5 6 12.6 4.8L13.5 3.9L14.3 4.7C14.5 4.9 14.7 5 15 5C15.3 5 15.5 4.9 15.7 4.7C16.1 4.3 16.1 3.7 15.7 3.3L12.7 0.3ZM7 14C4.2 14 2 11.8 2 9C2 6.2 4.2 4 7 4C9.8 4 12 6.2 12 9C12 11.8 9.8 14 7 14Z"
      fill="#DEC173"
    />
    <path d="M8 6H6V10H10V8H8V6Z" fill="#DEC173" />
  </svg>
);

// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
export const Pulse = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path
      opacity="0.15"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
      fill="#416CE9"
    />
    <path
      opacity="0.2"
      d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z"
      fill="#416CE9"
    />
    <path
      opacity="0.3"
      d="M6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z"
      fill="#416CE9"
    />
  </svg>
);

export const SimulateApp = ({ className, ...props }: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1695_23585)">
      <g clipPath="url(#clip1_1695_23585)">
        <path
          d="M14 23L15.9609 22.0141L20.1617 19.9133L22 16"
          stroke="#00CC8F"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24.4513 15.9059C25.3852 14.7569 25.5371 13.349 24.7905 12.7612C24.0439 12.1733 22.6816 12.6282 21.7476 13.7771C20.8137 14.9261 20.6619 16.3339 21.4085 16.9218C22.1551 17.5096 23.5174 17.0548 24.4513 15.9059Z"
          fill="#00CC8F"
        />
        <path
          d="M23 9L20.8509 8.04146L16.2383 6L12 7.01707"
          stroke="#00CC8F"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M11.1608 8.74396C12.7613 8.66858 14.019 7.79083 13.97 6.78346C13.9211 5.77608 12.5839 5.02054 10.9834 5.09592C9.38293 5.17131 8.12516 6.04907 8.17415 7.05645C8.22314 8.06383 9.56033 8.81935 11.1608 8.74396Z"
          fill="#00CC8F"
        />
        <path
          d="M5 9V11.1793V15.8414L7 19"
          stroke="#00CC8F"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M9.5108 23.0165C10.4297 22.5533 10.578 21.0315 9.84212 19.6175C9.10624 18.2034 7.76482 17.4325 6.84594 17.8957C5.92706 18.3589 5.77868 19.8807 6.51456 21.2948C7.25044 22.7088 8.59192 23.4797 9.5108 23.0165Z"
          fill="#00CC8F"
        />
        <path
          d="M1 7L13.9964 13L27 7"
          stroke="#4C516A"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M14 13V28"
          stroke="#4C516A"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M27 22.2092L13.9964 28L1 22.2092V6.78368L13.9964 1L27 6.78368V22.2092Z"
          stroke="#4C516A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <circle cx="22.5" cy="23.5" r="8.5" fill="white" />
      <path
        d="M28.8423 26.3935L25.8047 24.6405V22.3624L28.8423 20.6094L29.24 21.2988L26.6006 22.8229V24.1819L29.24 25.7059L28.8423 26.3952V26.3935Z"
        fill="#00CC8F"
      />
      <path
        d="M17.1699 26.3905L16.7725 25.7016L19.4118 24.1776V22.8186L16.7725 21.2948L17.1699 20.6055L20.2075 22.3585V24.637L17.1699 26.3905Z"
        fill="#00CC8F"
      />
      <path
        d="M25.4161 21.646L23.4438 20.5074V17H24.2394V20.048L25.4161 20.7274L28.0554 19.2033L28.4531 19.8926L25.4157 21.6456L25.4161 21.646Z"
        fill="#00CC8F"
      />
      <path
        d="M22.6294 29.9988H21.8337V26.9507L20.657 26.2714L18.0173 27.7955L17.6206 27.1065L20.658 25.3535L22.6294 26.4914V29.9988Z"
        fill="#00CC8F"
      />
      <path
        d="M20.657 21.646L17.6206 19.8924L18.0183 19.2031L20.6576 20.7272L21.8343 20.0478V17H22.63V20.5074L20.657 21.646Z"
        fill="#00CC8F"
      />
      <path
        d="M24.2394 29.9995H23.4438V26.4922L25.4161 25.3535L28.4535 27.1065L28.0558 27.7959L25.4165 26.2718L24.2398 26.9511V29.9995H24.2394Z"
        fill="#00CC8F"
      />
    </g>
    <defs>
      <clipPath id="clip0_1695_23585">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_1695_23585">
        <rect width="28" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SimulateAppBoxOnly = ({
  className,
  ...props
}: ComponentProps<"svg">) => (
  <svg
    className={className}
    width="39"
    height="41"
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3269_26499)">
      <path
        d="M19.0898 31.1909L21.9698 29.8909L28.1398 27.1209L30.8398 21.9609"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1041 21.4102C33.9942 20.2975 34.139 18.934 33.4274 18.3648C32.7158 17.7955 31.4173 18.236 30.5272 19.3487C29.6371 20.4613 29.4924 21.8248 30.204 22.394C30.9155 22.9633 32.214 22.5228 33.1041 21.4102Z"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M31.7798 11.6098L28.9098 10.2998L22.7498 7.50977L17.0898 8.89977"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.3237 10.9366C16.747 10.8685 17.8654 10.0754 17.8218 9.16513C17.7783 8.2549 16.5892 7.57222 15.1659 7.64034C13.7427 7.70845 12.6242 8.50157 12.6677 9.41179C12.7113 10.322 13.9004 11.0047 15.3237 10.9366Z"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.56006 12.2109V15.3709V22.1309L10.1601 26.7109"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4341 30.5378C13.2452 30.1224 13.3761 28.7575 12.7266 27.4893C12.077 26.2211 10.893 25.5297 10.0819 25.9451C9.27081 26.3605 9.13984 27.7254 9.78939 28.9936C10.4389 30.2618 11.623 30.9532 12.4341 30.5378Z"
        stroke="#00CC8F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 9.24023L19.09 17.3802L37.19 9.24023"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.1001 17.3809V39.1009"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.19 30.9496L19.09 39.0996L1 30.9496V9.23961L19.09 1.09961L37.19 9.23961V30.9496Z"
        stroke="#4C516A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_3269_26499">
        <rect width="38.19" height="40.19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
